import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ParametresService } from '../../core/parametres.service';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {
  constructor(
    private anneeService: ParametresService
  ) { }
  /**
   * Pour pouvoir accéder à l’année
   */
  private annee: string;
  /**
   * On veille à n’avoir qu’une subscription à année à la fois. Cette variable nous permet de la suivre.
   */
  private subscriptionAnnee: Subscription;
  /**
   * Fonctions utiles pour la validation des contrôles croisés
   */
  /**
   * Fonction appelée dans le formulaire service lors de la création d’un nouveau formulaire
   * @param rootForm La racine du formulaire en cours
   */
  public ajoutValidationCroisee(rootForm: UntypedFormGroup): void {
    // Gestion de la subscription à l’année année
    if (this.subscriptionAnnee && !this.subscriptionAnnee.closed) {
      this.subscriptionAnnee.unsubscribe();
    }
    /*
     * En faisant ainsi, on dispose de l’année dans les contrôles qui sont ensuite effectués.
     * Peut être nécessaire comme dans le cas de Conciliateurs, sinon il est possible de retirer l’appel à cette observable
     * et mettre directement nos valideurs.
     * */
    this.subscriptionAnnee = this.anneeService.getAnnee$().subscribe((annee) => {
      this.annee = annee;
      rootForm.get('dg').setValidators([
        this.ctrlDg1,
        this.ctrlDg2,
        this.ctrlDg3,
        this.ctrlDg4,
        this.ctrlDg5,
        this.ctrlDg6
      ]);
      rootForm.get('moyens').setValidators([
        this.ctrlA35,
        this.ctrlA36,
        this.ctrlA37,
        this.ctrlA38,
        this.ctrlA39,
        this.ctrlA40,
        this.ctrlA41,
        this.ctrlA42,
        this.ctrlA78,
        this.ctrlA79,
        this.ctrlA80,
        this.ctrlA81,
        this.ctrlA82,
        this.ctrlA83,
        this.ctrlA9,
        this.ctrlA84,
        this.ctrlA10,
        this.ctrlA85,
        this.ctrlA86,
        this.ctrlA87,
        this.ctrlA88,
        this.ctrlA89,
        this.ctrlA90,
        this.ctrlA91,
        this.ctrlA11,
        this.ctrlA92,
        this.ctrlA12,
        this.ctrlA93,
        this.ctrlA94,
        this.ctrlA95,
        this.ctrlA96,
        this.ctrlA97,
        this.ctrlA98,
        this.ctrlA99,
        this.ctrlA13,
        this.ctrlA100,
        this.ctrlA14,
        this.ctrlA101,
        this.ctrlA102,
        this.ctrlA45,
        this.ctrlA46,
        this.ctrlA47,
        this.ctrlA48,
        this.ctrlA49,
        this.ctrlA15,
        this.ctrlA50,
        this.ctrlA16,
        this.ctrlA51,
        this.ctrlA103,
        this.ctrlA104
      ]);
      rootForm.get('premiersContacts').setValidators([
        this.ctrlB1,
        this.ctrlB2,
        this.ctrlB3,
        this.ctrlB4,
        this.ctrlB5,
        this.ctrlB6
      ]);
      rootForm.get('personnesRecues').setValidators([
        this.ctrlC17,
        this.ctrlC18,
        this.ctrlC1,
        this.ctrlC19,
        this.ctrlC11,
        this.ctrlC12,
        this.ctrlC2,
        this.ctrlC13,
        this.ctrlC14,
        this.ctrlC3,
        this.ctrlC16,
        this.ctrlC4,
        this.ctrlC5,
        this.ctrlC6,
        this.ctrlC7,
        this.ctrlC8,
        this.ctrlC25,
        this.ctrlC9,
        this.ctrlC20,
        this.ctrlC10,
        this.ctrlC23,
        this.ctrlC24
      ]);
      rootForm.get('contexteFaitsProcedure').setValidators([
        this.ctrlD1,
        this.ctrlD2,
        this.ctrlD3,
        this.ctrlD4,
        this.ctrlD5,
        this.ctrlD6,
        this.ctrlD7
      ]);
      rootForm.get('aidesApportees').setValidators([
        this.ctrlE1,
        this.ctrlE2,
        this.ctrlE3,
        this.ctrlE4,
        this.ctrlE5,
        this.ctrlE6
      ]);
      rootForm.get('syntheseBav').setValidators([
        this.ctrlG1,
        this.ctrlG2,
        this.ctrlG3,
        this.ctrlG4,
        this.ctrlG5,
        this.ctrlG6,
        this.ctrlG7,
        this.ctrlG8,
        this.ctrlG9,
        this.ctrlG10,
        this.ctrlG11,
        this.ctrlG12,
        this.ctrlG13,
        this.ctrlG14,
        this.ctrlG15,
        this.ctrlG16,
        this.ctrlG17,
        this.ctrlG18,
        this.ctrlG19,
        this.ctrlG20,
        this.ctrlG21,
        this.ctrlG22,
        this.ctrlG23,
        this.ctrlG24,
        this.ctrlG25,
        this.ctrlG26,
        this.ctrlG27,
        this.ctrlG28,
        this.ctrlG29,
        this.ctrlG30,
        this.ctrlG31,
        this.ctrlG32,
        this.ctrlG33,
        this.ctrlG34,
        this.ctrlG35,
        this.ctrlG36,
        this.ctrlG37,
        this.ctrlG38,
        this.ctrlG39,
        this.ctrlG40,
        this.ctrlG41,
        this.ctrlG42,
        this.ctrlG43,
        this.ctrlG44,
        this.ctrlG45,
        this.ctrlG46,
        this.ctrlG47,
        this.ctrlG48,
        this.ctrlG49,
        this.ctrlG50,
        this.ctrlG51,
        this.ctrlG52,
        this.ctrlG53,
        this.ctrlG54,
        this.ctrlG55,
        this.ctrlG56,
        this.ctrlG57,
        this.ctrlG58,
        this.ctrlG59,
        this.ctrlG60,
        this.ctrlG61,
        this.ctrlG62,
        this.ctrlG63,
        this.ctrlG64,
        this.ctrlG65,
        this.ctrlG66,
        this.ctrlG67,
        this.ctrlG68,
        this.ctrlG69,
        this.ctrlG70,
        this.ctrlG71,
        this.ctrlG72,
        this.ctrlG73,
        this.ctrlG74,
        this.ctrlG75,
        this.ctrlG76,
        this.ctrlG77,
        this.ctrlG78,
        this.ctrlG79,
        this.ctrlG80,
        this.ctrlG81,
        this.ctrlG82,
        this.ctrlG83,
        this.ctrlG84
      ]);
      rootForm.updateValueAndValidity();
    });
  }

  /*** Debut Contrôles ***/
  /** Remarques : pour les controles bloquants liés à des variables obligatoires, 
  /**    on teste que la variable est renseignée pour activer le controle, pas besoin quand non renseignée puisque obligatoire! */

  /*** Controles sur DG ***/
  /************************/
  /* controle sur xxRecuTot*/
  private ctrlDg1: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const xxRecuTot = control.get('xxRecuTot').value;
    const xxRecuVict = Number(control.get('xxRecuVict').value);
    const xxRecuNvict = Number(control.get('xxRecuNvict').value);

    if (xxRecuTot === null && xxRecuVict === 0 && xxRecuNvict === 0) {
      resultat = false;
    } else {
      if (xxRecuTot !== null && Number(xxRecuTot) < (xxRecuVict + xxRecuNvict)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlDg1': { value: control.value } } : null;
  }

  /* controle sur xxPremContactRecuTot*/
  private ctrlDg2: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const xxPremContactRecuTot = control.get('xxPremContactRecuTot').value;
    const xxPremContactRecuVict = Number(control.get('xxPremContactRecuVict').value);
    const xxPremContactRecuNvict = Number(control.get('xxPremContactRecuNvict').value);

    if (xxPremContactRecuTot === null && xxPremContactRecuVict === 0 && xxPremContactRecuNvict === 0) {
      resultat = false;
    } else {
      if (xxPremContactRecuTot !== null && Number(xxPremContactRecuTot) < (xxPremContactRecuVict + xxPremContactRecuNvict)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlDg2': { value: control.value } } : null;
  }

  private ctrlDg6: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const xxPremContactRecuTot = control.get('xxPremContactRecuTot').value;
    const xxRecuTot = control.get('xxRecuTot').value;

    if (xxPremContactRecuTot === null && xxRecuTot === null) {
      resultat = false;
    } else {
      if (xxPremContactRecuTot !== null && Number(xxPremContactRecuTot) > Number(xxRecuTot)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlDg6': { value: control.value } } : null;
  }

  /* controle sur xxPremContactNrecuTot*/
  private ctrlDg3: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const xxPremContactNrecuTot = control.get('xxPremContactNrecuTot').value;
    const xxPremContactNrecuVict = Number(control.get('xxPremContactNrecuVict').value);
    const xxPremContactNrecuNvict = Number(control.get('xxPremContactNrecuNvict').value);

    if (xxPremContactNrecuTot === null && xxPremContactNrecuVict === 0 && xxPremContactNrecuNvict === 0) {
      resultat = false;
    } else {
      if (xxPremContactNrecuTot !== null && Number(xxPremContactNrecuTot) < (xxPremContactNrecuVict + xxPremContactNrecuNvict)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlDg3': { value: control.value } } : null;
  }

  /* controle pas de doublons sur les TJ saisis : xxTjIelst*/
  private ctrlDg4: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    const juridictions: UntypedFormArray = control.get('juridictions') as UntypedFormArray;
    let juridictionFiltree: string[] = [];
    let resultat: boolean = false;

    if (juridictions) {
      for (let index = 0; index < juridictions.controls.length; index++) {
        if (juridictionFiltree.find(valeur => valeur === juridictions.controls[index].get('xxTjIelst').value)) {
          resultat = true;
        } else {
          juridictionFiltree.push(juridictions.controls[index].get('xxTjIelst').value);
        }
      }
    }
    return resultat ? { 'ctrlDg4': { value: control.value } } : null;
  }

  /* controle pas de doublons sur les BAV saisis : xxBavIelst*/
  private ctrlDg5: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    const bavs: UntypedFormArray = control.get('listeBav') as UntypedFormArray;
    let bavFiltree: string[] = [];
    let resultat: boolean = false;

    if (bavs) {
      for (let index = 0; index < bavs.controls.length; index++) {
        if (bavFiltree.find(valeur => valeur === bavs.controls[index].get('xxBavIelst').value)) {
          resultat = true;
        } else {
          bavFiltree.push(bavs.controls[index].get('xxBavIelst').value);
        }
      }
    }
    return resultat ? { 'ctrlDg5': { value: control.value } } : null;
  }

  /*** Controles sur Moyens ***/
  /****************************/
  /* controle sur aaAssoNbCdi*/
  private ctrlA35: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaAssoUniqAav = control.get('aaAssoUniqAav').value;
    const aaAssoNbCdi = control.get('aaAssoNbCdi').value;
    const aaAssoNbCdiJur = Number(control.get('aaAssoNbCdiJur').value);
    const aaAssoNbCdiPsy = Number(control.get('aaAssoNbCdiPsy').value);
    const aaAssoNbCdiWsoc = Number(control.get('aaAssoNbCdiWsoc').value);

    if (aaAssoNbCdi === null && aaAssoNbCdiJur === 0 && aaAssoNbCdiPsy === 0 && aaAssoNbCdiWsoc === 0) {
      resultat = false;
    } else {
      if (aaAssoUniqAav === '1' && aaAssoNbCdi !== null && Number(aaAssoNbCdi) < (aaAssoNbCdiJur + aaAssoNbCdiPsy + aaAssoNbCdiWsoc)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlA35': { value: control.value } } : null;
  }
  /* controle sur aaAssoEtpCdi*/
  private ctrlA36: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaAssoUniqAav = control.get('aaAssoUniqAav').value;
    const aaAssoEtpCdi = control.get("aaAssoEtpCdi").value;
    const aaAssoEtpCdi_float = parseFloat(control.get("aaAssoEtpCdi").value) || 0;
    const aaAssoEtpCdiJur = parseFloat(control.get("aaAssoEtpCdiJur").value) || 0;
    const aaAssoEtpCdiPsy = parseFloat(control.get("aaAssoEtpCdiPsy").value) || 0;
    const aaAssoEtpCdiWsoc = parseFloat(control.get("aaAssoEtpCdiWsoc").value) || 0;
    // Pour ces variables décimales ETPT, le FloatInputComponent manipule les nombres décimaux
    // en virgule flottante avec 3 décimales après le séparateur décimal, alors qu'on souhaite seulement
    // 2 décimales dans l'interface et côté API, conformément à la spécification.
    // On cherche à comparer ces nombres décimaux en virgule flottante limités à 2 décimales
    // et non pas des string qui sont comparées selon les valeurs des codes Unicode des
    // caractères qu'elles contiennent : les number 11.11 > 2.22, mais les string '11.11' < '2.22'
    // Or la méthode toFixed(2) sur un number renvoie une string et non pas un number. A partir de la string
    // formatée par toFixed(2), il faut donc utiliser parseFloat() pour manipuler de nouveau un number.

    const sommeTableau = (aaAssoEtpCdiJur + aaAssoEtpCdiPsy + aaAssoEtpCdiWsoc);

    if (aaAssoUniqAav === '1' && aaAssoEtpCdi !== null && aaAssoEtpCdi !== '' && (parseFloat(aaAssoEtpCdi_float.toFixed(2)) < parseFloat(sommeTableau.toFixed(2)))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA36': { value: control.value } } : null;
  }
  /* controle sur aaAssoNbCdd*/
  private ctrlA37: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaAssoUniqAav = control.get('aaAssoUniqAav').value;
    const aaAssoNbCdd = control.get('aaAssoNbCdd').value;
    const aaAssoNbCddJur = Number(control.get('aaAssoNbCddJur').value);
    const aaAssoNbCddPsy = Number(control.get('aaAssoNbCddPsy').value);
    const aaAssoNbCddWsoc = Number(control.get('aaAssoNbCddWsoc').value);

    if (aaAssoNbCdd === null && aaAssoNbCddJur === 0 && aaAssoNbCddPsy === 0 && aaAssoNbCddWsoc === 0) {
      resultat = false;
    } else {
      if (aaAssoUniqAav === '1' && aaAssoNbCdd !== null && Number(aaAssoNbCdd) < (aaAssoNbCddJur + aaAssoNbCddPsy + aaAssoNbCddWsoc)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlA37': { value: control.value } } : null;
  }
  /* controle sur aaAssoEtpCdd*/
  private ctrlA38: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaAssoUniqAav = control.get('aaAssoUniqAav').value;
    const aaAssoEtpCdd = control.get("aaAssoEtpCdd").value;
    const aaAssoEtpCdd_float = parseFloat(control.get("aaAssoEtpCdd").value) || 0;
    const aaAssoEtpCddJur = parseFloat(control.get("aaAssoEtpCddJur").value) || 0;
    const aaAssoEtpCddPsy = parseFloat(control.get("aaAssoEtpCddPsy").value) || 0;
    const aaAssoEtpCddWsoc = parseFloat(control.get("aaAssoEtpCddWsoc").value) || 0;
    // Pour ces variables décimales ETPT, le FloatInputComponent manipule les nombres décimaux
    // en virgule flottante avec 3 décimales après le séparateur décimal, alors qu'on souhaite seulement
    // 2 décimales dans l'interface et côté API, conformément à la spécification.
    // On cherche à comparer ces nombres décimaux en virgule flottante limités à 2 décimales
    // et non pas des string qui sont comparées selon les valeurs des codes Unicode des
    // caractères qu'elles contiennent : les number 11.11 > 2.22, mais les string '11.11' < '2.22'
    // Or la méthode toFixed(2) sur un number renvoie une string et non pas un number. A partir de la string
    // formatée par toFixed(2), il faut donc utiliser parseFloat() pour manipuler de nouveau un number.

    const sommeTableau = (aaAssoEtpCddJur + aaAssoEtpCddPsy + aaAssoEtpCddWsoc);

    if (aaAssoUniqAav === '1' && aaAssoEtpCdd !== null && aaAssoEtpCdd !== '' && (parseFloat(aaAssoEtpCdd_float.toFixed(2)) < parseFloat(sommeTableau.toFixed(2)))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA38': { value: control.value } } : null;
  }
  /* controle sur aaAssoNbPresta*/
  private ctrlA39: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaAssoUniqAav = control.get('aaAssoUniqAav').value;
    const aaAssoNbPresta = control.get('aaAssoNbPresta').value;
    const aaAssoNbPrestaJur = Number(control.get('aaAssoNbPrestaJur').value);
    const aaAssoNbPrestaPsy = Number(control.get('aaAssoNbPrestaPsy').value);
    const aaAssoNbPrestaWsoc = Number(control.get('aaAssoNbPrestaWsoc').value);

    if (aaAssoNbPresta === null && aaAssoNbPrestaJur === 0 && aaAssoNbPrestaPsy === 0 && aaAssoNbPrestaWsoc === 0) {
      resultat = false;
    } else {
      if (aaAssoUniqAav === '1' && aaAssoNbPresta !== null && Number(aaAssoNbPresta) < (aaAssoNbPrestaJur + aaAssoNbPrestaPsy + aaAssoNbPrestaWsoc)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlA39': { value: control.value } } : null;
  }
  /* controle sur aaAssoEtpPresta*/
  private ctrlA40: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaAssoUniqAav = control.get('aaAssoUniqAav').value;
    const aaAssoEtpPresta = control.get("aaAssoEtpPresta").value;
    const aaAssoEtpPresta_float = parseFloat(control.get("aaAssoEtpPresta").value) || 0;
    const aaAssoEtpPrestaJur = parseFloat(control.get("aaAssoEtpPrestaJur").value) || 0;
    const aaAssoEtpPrestaPsy = parseFloat(control.get("aaAssoEtpPrestaPsy").value) || 0;
    const aaAssoEtpPrestaWsoc = parseFloat(control.get("aaAssoEtpPrestaWsoc").value) || 0;
    // Pour ces variables décimales ETPT, le FloatInputComponent manipule les nombres décimaux
    // en virgule flottante avec 3 décimales après le séparateur décimal, alors qu'on souhaite seulement
    // 2 décimales dans l'interface et côté API, conformément à la spécification.
    // On cherche à comparer ces nombres décimaux en virgule flottante limités à 2 décimales
    // et non pas des string qui sont comparées selon les valeurs des codes Unicode des
    // caractères qu'elles contiennent : les number 11.11 > 2.22, mais les string '11.11' < '2.22'
    // Or la méthode toFixed(2) sur un number renvoie une string et non pas un number. A partir de la string
    // formatée par toFixed(2), il faut donc utiliser parseFloat() pour manipuler de nouveau un number.

    const sommeTableau = (aaAssoEtpPrestaJur + aaAssoEtpPrestaPsy + aaAssoEtpPrestaWsoc);

    if (aaAssoUniqAav === '1' && aaAssoEtpPresta !== null && aaAssoEtpPresta !== '' && (parseFloat(aaAssoEtpPresta_float.toFixed(2)) < parseFloat(sommeTableau.toFixed(2)))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA40': { value: control.value } } : null;
  }
  /* controle sur aaAssoNbBnvl*/
  private ctrlA41: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaAssoUniqAav = control.get('aaAssoUniqAav').value;
    const aaAssoNbBnvl = control.get('aaAssoNbBnvl').value;
    const aaAssoNbBnvlJur = Number(control.get('aaAssoNbBnvlJur').value);
    const aaAssoNbBnvlPsy = Number(control.get('aaAssoNbBnvlPsy').value);
    const aaAssoNbBnvlWsoc = Number(control.get('aaAssoNbBnvlWsoc').value);

    if (aaAssoNbBnvl === null && aaAssoNbBnvlJur === 0 && aaAssoNbBnvlPsy === 0 && aaAssoNbBnvlWsoc === 0) {
      resultat = false;
    } else {
      if (aaAssoUniqAav === '1' && aaAssoNbBnvl !== null && Number(aaAssoNbBnvl) < (aaAssoNbBnvlJur + aaAssoNbBnvlPsy + aaAssoNbBnvlWsoc)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlA41': { value: control.value } } : null;
  }
  /* controle sur aaAssoEtpBnvl*/
  private ctrlA42: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaAssoUniqAav = control.get('aaAssoUniqAav').value;
    const aaAssoEtpBnvl = control.get("aaAssoEtpBnvl").value;
    const aaAssoEtpBnvl_float = parseFloat(control.get("aaAssoEtpBnvl").value) || 0;
    const aaAssoEtpBnvlJur = parseFloat(control.get("aaAssoEtpBnvlJur").value) || 0;
    const aaAssoEtpBnvlPsy = parseFloat(control.get("aaAssoEtpBnvlPsy").value) || 0;
    const aaAssoEtpBnvlWsoc = parseFloat(control.get("aaAssoEtpBnvlWsoc").value) || 0;
    // Pour ces variables décimales ETPT, le FloatInputComponent manipule les nombres décimaux
    // en virgule flottante avec 3 décimales après le séparateur décimal, alors qu'on souhaite seulement
    // 2 décimales dans l'interface et côté API, conformément à la spécification.
    // On cherche à comparer ces nombres décimaux en virgule flottante limités à 2 décimales
    // et non pas des string qui sont comparées selon les valeurs des codes Unicode des
    // caractères qu'elles contiennent : les number 11.11 > 2.22, mais les string '11.11' < '2.22'
    // Or la méthode toFixed(2) sur un number renvoie une string et non pas un number. A partir de la string
    // formatée par toFixed(2), il faut donc utiliser parseFloat() pour manipuler de nouveau un number.

    const sommeTableau = (aaAssoEtpBnvlJur + aaAssoEtpBnvlPsy + aaAssoEtpBnvlWsoc);

    if (aaAssoUniqAav === '1' && aaAssoEtpBnvl !== null && aaAssoEtpBnvl !== '' && (parseFloat(aaAssoEtpBnvl_float.toFixed(2)) < parseFloat(sommeTableau.toFixed(2)))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA42': { value: control.value } } : null;
  }

  /* controle sur aaNbCdiJur*/
  private ctrlA78: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaNbCdiJur = control.get('aaNbCdiJur').value;
    const aaAssoNbCdiJur = control.get('aaAssoNbCdiJur').value;

    if (aaNbCdiJur !== null && aaAssoNbCdiJur !== null && Number(aaNbCdiJur) > Number(aaAssoNbCdiJur)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA78': { value: control.value } } : null;
  }

  /* controle sur aaEtpCdiJur*/
  private ctrlA79: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaEtpCdiJur = control.get("aaEtpCdiJur").value;
    const aaEtpCdiJur_float = parseFloat(control.get("aaEtpCdiJur").value) || 0;
    const aaAssoEtpCdiJur = control.get("aaAssoEtpCdiJur").value;
    const aaAssoEtpCdiJur_float = parseFloat(control.get("aaAssoEtpCdiJur").value) || 0;

    if (aaEtpCdiJur !== null && aaEtpCdiJur !== '' && aaAssoEtpCdiJur !== null && aaAssoEtpCdiJur !== '' && parseFloat(aaEtpCdiJur_float.toFixed(2)) > parseFloat(aaAssoEtpCdiJur_float.toFixed(2))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA79': { value: control.value } } : null;
  }

  /* controle sur aaNbCdiPsy*/
  private ctrlA80: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaNbCdiPsy = control.get('aaNbCdiPsy').value;
    const aaAssoNbCdiPsy = control.get('aaAssoNbCdiPsy').value;

    if (aaNbCdiPsy !== null && aaAssoNbCdiPsy !== null && Number(aaNbCdiPsy) > Number(aaAssoNbCdiPsy)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA80': { value: control.value } } : null;
  }

  /* controle sur aaEtpCdiPsy*/
  private ctrlA81: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaEtpCdiPsy = control.get("aaEtpCdiPsy").value;
    const aaEtpCdiPsy_float = parseFloat(control.get("aaEtpCdiPsy").value) || 0;
    const aaAssoEtpCdiPsy = control.get("aaAssoEtpCdiPsy").value;
    const aaAssoEtpCdiPsy_float = parseFloat(control.get("aaAssoEtpCdiPsy").value) || 0;

    if (aaEtpCdiPsy !== null && aaEtpCdiPsy !== '' && aaAssoEtpCdiPsy !== null && aaAssoEtpCdiPsy !== '' && parseFloat(aaEtpCdiPsy_float.toFixed(2)) > parseFloat(aaAssoEtpCdiPsy_float.toFixed(2))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA81': { value: control.value } } : null;
  }

  /* controle sur aaNbCdiWsoc*/
  private ctrlA82: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaNbCdiWsoc = control.get('aaNbCdiWsoc').value;
    const aaAssoNbCdiWsoc = control.get('aaAssoNbCdiWsoc').value;

    if (aaNbCdiWsoc !== null && aaAssoNbCdiWsoc !== null && Number(aaNbCdiWsoc) > Number(aaAssoNbCdiWsoc)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA82': { value: control.value } } : null;
  }

  /* controle sur aaEtpCdiWsoc*/
  private ctrlA83: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaEtpCdiWsoc = control.get("aaEtpCdiWsoc").value;
    const aaEtpCdiWsoc_float = parseFloat(control.get("aaEtpCdiWsoc").value) || 0;
    const aaAssoEtpCdiWsoc = control.get("aaAssoEtpCdiWsoc").value;
    const aaAssoEtpCdiWsoc_float = parseFloat(control.get("aaAssoEtpCdiWsoc").value) || 0;

    if (aaEtpCdiWsoc !== null && aaEtpCdiWsoc !== '' && aaAssoEtpCdiWsoc !== null && aaAssoEtpCdiWsoc !== '' && parseFloat(aaEtpCdiWsoc_float.toFixed(2)) > parseFloat(aaAssoEtpCdiWsoc_float.toFixed(2))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA83': { value: control.value } } : null;
  }

  /* controle sur aaNbCdiTot*/
  private ctrlA9: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaNbCdiTot = control.get('aaNbCdiTot').value;
    const aaNbCdiAav = Number(control.get('aaNbCdiAav').value);
    const aaNbCdiJur = Number(control.get('aaNbCdiJur').value);
    const aaNbCdiPsy = Number(control.get('aaNbCdiPsy').value);
    const aaNbCdiWsoc = Number(control.get('aaNbCdiWsoc').value);
    const aaNbCdiAutrInterv = Number(control.get('aaNbCdiAutrInterv').value);
    const aaNbCdiDir = Number(control.get('aaNbCdiDir').value);
    const aaNbCdiComptsecr = Number(control.get('aaNbCdiComptsecr').value);
    const aaNbCdiAutrSupport = Number(control.get('aaNbCdiAutrSupport').value);

    if (aaNbCdiTot === null && aaNbCdiAav === 0 && aaNbCdiJur === 0 && aaNbCdiPsy === 0 && aaNbCdiWsoc === 0 && aaNbCdiAutrInterv === 0 && aaNbCdiDir === 0 && aaNbCdiComptsecr === 0 && aaNbCdiAutrSupport === 0) {
      resultat = false;
    } else {
      if (aaNbCdiTot !== null && Number(aaNbCdiTot) < (aaNbCdiAav + aaNbCdiJur + aaNbCdiPsy + aaNbCdiWsoc + aaNbCdiAutrInterv + aaNbCdiDir + aaNbCdiComptsecr + aaNbCdiAutrSupport)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlA9': { value: control.value } } : null;
  }

  /* controle sur aaNbCdiTot*/
  private ctrlA84: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaNbCdiTot = control.get('aaNbCdiTot').value;
    const aaAssoNbCdi = control.get('aaAssoNbCdi').value;

    if (aaNbCdiTot !== null && aaAssoNbCdi !== null && Number(aaNbCdiTot) > Number(aaAssoNbCdi)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA84': { value: control.value } } : null;
  }

  /* controle sur aaEtpCdiTot*/
  private ctrlA10: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaEtpCdiTot = control.get("aaEtpCdiTot").value;
    const aaEtpCdiTot_float = parseFloat(control.get("aaEtpCdiTot").value) || 0;
    const aaEtpCdiAav = parseFloat(control.get("aaEtpCdiAav").value) || 0;
    const aaEtpCdiJur = parseFloat(control.get("aaEtpCdiJur").value) || 0;
    const aaEtpCdiPsy = parseFloat(control.get("aaEtpCdiPsy").value) || 0;
    const aaEtpCdiWsoc = parseFloat(control.get("aaEtpCdiWsoc").value) || 0;
    const aaEtpCdiAutrInterv = parseFloat(control.get("aaEtpCdiAutrInterv").value) || 0;
    const aaEtpCdiDir = parseFloat(control.get("aaEtpCdiDir").value) || 0;
    const aaEtpCdiComptsecr = parseFloat(control.get("aaEtpCdiComptsecr").value) || 0;
    const aaEtpCdiAutrSupport = parseFloat(control.get("aaEtpCdiAutrSupport").value) || 0;
    // Pour ces variables décimales ETPT, le FloatInputComponent manipule les nombres décimaux
    // en virgule flottante avec 3 décimales après le séparateur décimal, alors qu'on souhaite seulement
    // 2 décimales dans l'interface et côté API, conformément à la spécification.
    // On cherche à comparer ces nombres décimaux en virgule flottante limités à 2 décimales
    // et non pas des string qui sont comparées selon les valeurs des codes Unicode des
    // caractères qu'elles contiennent : les number 11.11 > 2.22, mais les string '11.11' < '2.22'
    // Or la méthode toFixed(2) sur un number renvoie une string et non pas un number. A partir de la string
    // formatée par toFixed(2), il faut donc utiliser parseFloat() pour manipuler de nouveau un number.

    const sommeTableau = (aaEtpCdiAav + aaEtpCdiJur + aaEtpCdiPsy + aaEtpCdiWsoc + aaEtpCdiAutrInterv + aaEtpCdiDir + aaEtpCdiComptsecr + aaEtpCdiAutrSupport);

    if (aaEtpCdiTot !== null && aaEtpCdiTot !== '' && (parseFloat(aaEtpCdiTot_float.toFixed(2)) < parseFloat(sommeTableau.toFixed(2)))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA10': { value: control.value } } : null;
  }

  /* controle sur aaEtpCdiTot*/
  private ctrlA85: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaEtpCdiTot = control.get("aaEtpCdiTot").value;
    const aaEtpCdiTot_float = parseFloat(control.get("aaEtpCdiTot").value) || 0;
    const aaAssoEtpCdi = control.get("aaAssoEtpCdi").value;
    const aaAssoEtpCdi_float = parseFloat(control.get("aaAssoEtpCdi").value) || 0;

    if (aaEtpCdiTot !== null && aaEtpCdiTot !== '' && aaAssoEtpCdi !== null && aaAssoEtpCdi !== '' && parseFloat(aaEtpCdiTot_float.toFixed(2)) > parseFloat(aaAssoEtpCdi_float.toFixed(2))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA85': { value: control.value } } : null;
  }

  /* controle sur aaNbCddJur*/
  private ctrlA86: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaNbCddJur = control.get('aaNbCddJur').value;
    const aaAssoNbCddJur = control.get('aaAssoNbCddJur').value;

    if (aaNbCddJur !== null && aaAssoNbCddJur !== null && Number(aaNbCddJur) > Number(aaAssoNbCddJur)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA86': { value: control.value } } : null;
  }

  /* controle sur aaEtpCddJur*/
  private ctrlA87: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaEtpCddJur = control.get("aaEtpCddJur").value;
    const aaEtpCddJur_float = parseFloat(control.get("aaEtpCddJur").value) || 0;
    const aaAssoEtpCddJur = control.get("aaAssoEtpCddJur").value;
    const aaAssoEtpCddJur_float = parseFloat(control.get("aaAssoEtpCddJur").value) || 0;

    if (aaEtpCddJur !== null && aaEtpCddJur !== '' && aaAssoEtpCddJur !== null && aaAssoEtpCddJur !== '' && parseFloat(aaEtpCddJur_float.toFixed(2)) > parseFloat(aaAssoEtpCddJur_float.toFixed(2))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA87': { value: control.value } } : null;
  }

  /* controle sur aaNbCddPsy*/
  private ctrlA88: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaNbCddPsy = control.get('aaNbCddPsy').value;
    const aaAssoNbCddPsy = control.get('aaAssoNbCddPsy').value;

    if (aaNbCddPsy !== null && aaAssoNbCddPsy !== null && Number(aaNbCddPsy) > Number(aaAssoNbCddPsy)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA88': { value: control.value } } : null;
  }

  /* controle sur aaEtpCddPsy*/
  private ctrlA89: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaEtpCddPsy = control.get("aaEtpCddPsy").value;
    const aaEtpCddPsy_float = parseFloat(control.get("aaEtpCddPsy").value) || 0;
    const aaAssoEtpCddPsy = control.get("aaAssoEtpCddPsy").value;
    const aaAssoEtpCddPsy_float = parseFloat(control.get("aaAssoEtpCddPsy").value) || 0;

    if (aaEtpCddPsy !== null && aaEtpCddPsy !== '' && aaAssoEtpCddPsy !== null && aaAssoEtpCddPsy !== '' && parseFloat(aaEtpCddPsy_float.toFixed(2)) > parseFloat(aaAssoEtpCddPsy_float.toFixed(2))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA89': { value: control.value } } : null;
  }

  /* controle sur aaNbCddWsoc*/
  private ctrlA90: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaNbCddWsoc = control.get('aaNbCddWsoc').value;
    const aaAssoNbCddWsoc = control.get('aaAssoNbCddWsoc').value;

    if (aaNbCddWsoc !== null && aaAssoNbCddWsoc !== null && Number(aaNbCddWsoc) > Number(aaAssoNbCddWsoc)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA90': { value: control.value } } : null;
  }
  /* controle sur aaEtpCddWsoc*/
  private ctrlA91: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaEtpCddWsoc = control.get("aaEtpCddWsoc").value;
    const aaEtpCddWsoc_float = parseFloat(control.get("aaEtpCddWsoc").value) || 0;
    const aaAssoEtpCddWsoc = control.get("aaAssoEtpCddWsoc").value;
    const aaAssoEtpCddWsoc_float = parseFloat(control.get("aaAssoEtpCddWsoc").value) || 0;

    if (aaEtpCddWsoc !== null && aaEtpCddWsoc !== '' && aaAssoEtpCddWsoc !== null && aaAssoEtpCddWsoc !== '' && parseFloat(aaEtpCddWsoc_float.toFixed(2)) > parseFloat(aaAssoEtpCddWsoc_float.toFixed(2))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA91': { value: control.value } } : null;
  }

  /* controle sur aaNbCddTot*/
  private ctrlA11: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaNbCddTot = control.get('aaNbCddTot').value;
    const aaNbCddAav = Number(control.get('aaNbCddAav').value);
    const aaNbCddJur = Number(control.get('aaNbCddJur').value);
    const aaNbCddPsy = Number(control.get('aaNbCddPsy').value);
    const aaNbCddWsoc = Number(control.get('aaNbCddWsoc').value);
    const aaNbCddAutrInterv = Number(control.get('aaNbCddAutrInterv').value);
    const aaNbCddDir = Number(control.get('aaNbCddDir').value);
    const aaNbCddComptsecr = Number(control.get('aaNbCddComptsecr').value);
    const aaNbCddAutrSupport = Number(control.get('aaNbCddAutrSupport').value);

    if (aaNbCddTot === null && aaNbCddAav === 0 && aaNbCddJur === 0 && aaNbCddPsy === 0 && aaNbCddWsoc === 0 && aaNbCddAutrInterv === 0 && aaNbCddDir === 0 && aaNbCddComptsecr === 0 && aaNbCddAutrSupport === 0) {
      resultat = false;
    } else {
      if (aaNbCddTot !== null && Number(aaNbCddTot) < (aaNbCddAav + aaNbCddJur + aaNbCddPsy + aaNbCddWsoc + aaNbCddAutrInterv + aaNbCddDir + aaNbCddComptsecr + aaNbCddAutrSupport)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlA11': { value: control.value } } : null;
  }

  /* controle sur aaNbCddTot*/
  private ctrlA92: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaNbCddTot = control.get('aaNbCddTot').value;
    const aaAssoNbCdd = control.get('aaAssoNbCdd').value;

    if (aaNbCddTot !== null && aaAssoNbCdd !== null && Number(aaNbCddTot) > Number(aaAssoNbCdd)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA92': { value: control.value } } : null;
  }

  /* controle sur aaEtpCddTot*/
  private ctrlA12: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaEtpCddTot = control.get("aaEtpCddTot").value;
    const aaEtpCddTot_float = parseFloat(control.get("aaEtpCddTot").value) || 0;
    const aaEtpCddAav = parseFloat(control.get("aaEtpCddAav").value) || 0;
    const aaEtpCddJur = parseFloat(control.get("aaEtpCddJur").value) || 0;
    const aaEtpCddPsy = parseFloat(control.get("aaEtpCddPsy").value) || 0;
    const aaEtpCddWsoc = parseFloat(control.get("aaEtpCddWsoc").value) || 0;
    const aaEtpCddAutrInterv = parseFloat(control.get("aaEtpCddAutrInterv").value) || 0;
    const aaEtpCddDir = parseFloat(control.get("aaEtpCddDir").value) || 0;
    const aaEtpCddComptsecr = parseFloat(control.get("aaEtpCddComptsecr").value) || 0;
    const aaEtpCddAutrSupport = parseFloat(control.get("aaEtpCddAutrSupport").value) || 0;
    // Pour ces variables décimales ETPT, le FloatInputComponent manipule les nombres décimaux
    // en virgule flottante avec 3 décimales après le séparateur décimal, alors qu'on souhaite seulement
    // 2 décimales dans l'interface et côté API, conformément à la spécification.
    // On cherche à comparer ces nombres décimaux en virgule flottante limités à 2 décimales
    // et non pas des string qui sont comparées selon les valeurs des codes Unicode des
    // caractères qu'elles contiennent : les number 11.11 > 2.22, mais les string '11.11' < '2.22'
    // Or la méthode toFixed(2) sur un number renvoie une string et non pas un number. A partir de la string
    // formatée par toFixed(2), il faut donc utiliser parseFloat() pour manipuler de nouveau un number.

    const sommeTableau = (aaEtpCddAav + aaEtpCddJur + aaEtpCddPsy + aaEtpCddWsoc + aaEtpCddAutrInterv + aaEtpCddDir + aaEtpCddComptsecr + aaEtpCddAutrSupport);

    if (aaEtpCddTot !== null && aaEtpCddTot !== '' && (parseFloat(aaEtpCddTot_float.toFixed(2)) < parseFloat(sommeTableau.toFixed(2)))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA12': { value: control.value } } : null;
  }

  /* controle sur aaEtpCddTot*/
  private ctrlA93: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaEtpCddTot = control.get("aaEtpCddTot").value;
    const aaEtpCddTot_float = parseFloat(control.get("aaEtpCddTot").value) || 0;
    const aaAssoEtpCdd = control.get("aaAssoEtpCdd").value;
    const aaAssoEtpCdd_float = parseFloat(control.get("aaAssoEtpCdd").value) || 0;

    if (aaEtpCddTot !== null && aaEtpCddTot !== '' && aaAssoEtpCdd !== null && aaAssoEtpCdd !== '' && parseFloat(aaEtpCddTot_float.toFixed(2)) > parseFloat(aaAssoEtpCdd_float.toFixed(2))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA93': { value: control.value } } : null;
  }

  /* controle sur aaNbPrestaJur*/
  private ctrlA94: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaNbPrestaJur = control.get('aaNbPrestaJur').value;
    const aaAssoNbPrestaJur = control.get('aaAssoNbPrestaJur').value;

    if (aaNbPrestaJur !== null && aaAssoNbPrestaJur !== null && Number(aaNbPrestaJur) > Number(aaAssoNbPrestaJur)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA94': { value: control.value } } : null;
  }

  /* controle sur aaEtpPrestaJur*/
  private ctrlA95: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaEtpPrestaJur = control.get("aaEtpPrestaJur").value;
    const aaEtpPrestaJur_float = parseFloat(control.get("aaEtpPrestaJur").value) || 0;
    const aaAssoEtpPrestaJur = control.get("aaAssoEtpPrestaJur").value;
    const aaAssoEtpPrestaJur_float = parseFloat(control.get("aaAssoEtpPrestaJur").value) || 0;

    if (aaEtpPrestaJur !== null && aaEtpPrestaJur !== '' && aaAssoEtpPrestaJur !== null && aaAssoEtpPrestaJur !== '' && parseFloat(aaEtpPrestaJur_float.toFixed(2)) > parseFloat(aaAssoEtpPrestaJur_float.toFixed(2))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA95': { value: control.value } } : null;
  }

  /* controle sur aaNbPrestaPsy*/
  private ctrlA96: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaNbPrestaPsy = control.get('aaNbPrestaPsy').value;
    const aaAssoNbPrestaPsy = control.get('aaAssoNbPrestaPsy').value;

    if (aaNbPrestaPsy !== null && aaAssoNbPrestaPsy !== null && Number(aaNbPrestaPsy) > Number(aaAssoNbPrestaPsy)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA96': { value: control.value } } : null;
  }

  /* controle sur aaEtpPrestaPsy*/
  private ctrlA97: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaEtpPrestaPsy = control.get("aaEtpPrestaPsy").value;
    const aaEtpPrestaPsy_float = parseFloat(control.get("aaEtpPrestaPsy").value) || 0;
    const aaAssoEtpPrestaPsy = control.get("aaAssoEtpPrestaPsy").value;
    const aaAssoEtpPrestaPsy_float = parseFloat(control.get("aaAssoEtpPrestaPsy").value) || 0;

    if (aaEtpPrestaPsy !== null && aaEtpPrestaPsy !== '' && aaAssoEtpPrestaPsy !== null && aaAssoEtpPrestaPsy !== '' && parseFloat(aaEtpPrestaPsy_float.toFixed(2)) > parseFloat(aaAssoEtpPrestaPsy_float.toFixed(2))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA97': { value: control.value } } : null;
  }

  /* controle sur aaNbPrestaWsoc*/
  private ctrlA98: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaNbPrestaWsoc = control.get('aaNbPrestaWsoc').value;
    const aaAssoNbPrestaWsoc = control.get('aaAssoNbPrestaWsoc').value;

    if (aaNbPrestaWsoc !== null && aaAssoNbPrestaWsoc !== null && Number(aaNbPrestaWsoc) > Number(aaAssoNbPrestaWsoc)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA98': { value: control.value } } : null;
  }
  /* controle sur aaEtpPrestaWsoc*/
  private ctrlA99: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaEtpPrestaWsoc = control.get("aaEtpPrestaWsoc").value;
    const aaEtpPrestaWsoc_float = parseFloat(control.get("aaEtpPrestaWsoc").value) || 0;
    const aaAssoEtpPrestaWsoc = control.get("aaAssoEtpPrestaWsoc").value;
    const aaAssoEtpPrestaWsoc_float = parseFloat(control.get("aaAssoEtpPrestaWsoc").value) || 0;

    if (aaEtpPrestaWsoc !== null && aaEtpPrestaWsoc !== '' && aaAssoEtpPrestaWsoc !== null && aaAssoEtpPrestaWsoc !== '' && parseFloat(aaEtpPrestaWsoc_float.toFixed(2)) > parseFloat(aaAssoEtpPrestaWsoc_float.toFixed(2))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA99': { value: control.value } } : null;
  }
  /* controle sur aaNbPrestaTot*/
  private ctrlA13: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaNbPrestaTot = control.get('aaNbPrestaTot').value;
    const aaNbPrestaAav = Number(control.get('aaNbPrestaAav').value);
    const aaNbPrestaJur = Number(control.get('aaNbPrestaJur').value);
    const aaNbPrestaPsy = Number(control.get('aaNbPrestaPsy').value);
    const aaNbPrestaWsoc = Number(control.get('aaNbPrestaWsoc').value);
    const aaNbPrestaAutrInterv = Number(control.get('aaNbPrestaAutrInterv').value);
    const aaNbPrestaDir = Number(control.get('aaNbPrestaDir').value);
    const aaNbPrestaComptsecr = Number(control.get('aaNbPrestaComptsecr').value);
    const aaNbPrestaAutrSupport = Number(control.get('aaNbPrestaAutrSupport').value);

    if (aaNbPrestaTot === null && aaNbPrestaAav === 0 && aaNbPrestaJur === 0 && aaNbPrestaPsy === 0 && aaNbPrestaWsoc === 0 && aaNbPrestaAutrInterv === 0 && aaNbPrestaDir === 0 && aaNbPrestaComptsecr === 0 && aaNbPrestaAutrSupport === 0) {
      resultat = false;
    } else {
      if (aaNbPrestaTot !== null && Number(aaNbPrestaTot) < (aaNbPrestaAav + aaNbPrestaJur + aaNbPrestaPsy + aaNbPrestaWsoc + aaNbPrestaAutrInterv + aaNbPrestaDir + aaNbPrestaComptsecr + aaNbPrestaAutrSupport)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlA13': { value: control.value } } : null;
  }
  /* controle sur aaNbPrestaTot*/
  private ctrlA100: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaNbPrestaTot = control.get('aaNbPrestaTot').value;
    const aaAssoNbPresta = control.get('aaAssoNbPresta').value;

    if (aaNbPrestaTot !== null && aaAssoNbPresta !== null && Number(aaNbPrestaTot) > Number(aaAssoNbPresta)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA100': { value: control.value } } : null;
  }
  /* controle sur aaEtpPrestaTot*/
  private ctrlA14: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaEtpPrestaTot = control.get("aaEtpPrestaTot").value;
    const aaEtpPrestaTot_float = parseFloat(control.get("aaEtpPrestaTot").value) || 0;
    const aaEtpPrestaAav = parseFloat(control.get("aaEtpPrestaAav").value) || 0;
    const aaEtpPrestaJur = parseFloat(control.get("aaEtpPrestaJur").value) || 0;
    const aaEtpPrestaPsy = parseFloat(control.get("aaEtpPrestaPsy").value) || 0;
    const aaEtpPrestaWsoc = parseFloat(control.get("aaEtpPrestaWsoc").value) || 0;
    const aaEtpPrestaAutrInterv = parseFloat(control.get("aaEtpPrestaAutrInterv").value) || 0;
    const aaEtpPrestaDir = parseFloat(control.get("aaEtpPrestaDir").value) || 0;
    const aaEtpPrestaComptsecr = parseFloat(control.get("aaEtpPrestaComptsecr").value) || 0;
    const aaEtpPrestaAutrSupport = parseFloat(control.get("aaEtpPrestaAutrSupport").value) || 0;
    // Pour ces variables décimales ETPT, le FloatInputComponent manipule les nombres décimaux
    // en virgule flottante avec 3 décimales après le séparateur décimal, alors qu'on souhaite seulement
    // 2 décimales dans l'interface et côté API, conformément à la spécification.
    // On cherche à comparer ces nombres décimaux en virgule flottante limités à 2 décimales
    // et non pas des string qui sont comparées selon les valeurs des codes Unicode des
    // caractères qu'elles contiennent : les number 11.11 > 2.22, mais les string '11.11' < '2.22'
    // Or la méthode toFixed(2) sur un number renvoie une string et non pas un number. A partir de la string
    // formatée par toFixed(2), il faut donc utiliser parseFloat() pour manipuler de nouveau un number.

    const sommeTableau = (aaEtpPrestaAav + aaEtpPrestaJur + aaEtpPrestaPsy + aaEtpPrestaWsoc + aaEtpPrestaAutrInterv + aaEtpPrestaDir + aaEtpPrestaComptsecr + aaEtpPrestaAutrSupport);

    if (aaEtpPrestaTot !== null && aaEtpPrestaTot !== '' && (parseFloat(aaEtpPrestaTot_float.toFixed(2)) < parseFloat(sommeTableau.toFixed(2)))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA14': { value: control.value } } : null;
  }
  /* controle sur aaEtpPrestaTot*/
  private ctrlA101: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaEtpPrestaTot = control.get("aaEtpPrestaTot").value;
    const aaEtpPrestaTot_float = parseFloat(control.get("aaEtpPrestaTot").value) || 0;
    const aaAssoEtpPresta = control.get("aaAssoEtpPresta").value;
    const aaAssoEtpPresta_float = parseFloat(control.get("aaAssoEtpPresta").value) || 0;

    if (aaEtpPrestaTot !== null && aaEtpPrestaTot !== '' && aaAssoEtpPresta !== null && aaAssoEtpPresta !== '' && parseFloat(aaEtpPrestaTot_float.toFixed(2)) > parseFloat(aaAssoEtpPresta_float.toFixed(2))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA101': { value: control.value } } : null;
  }
  /* controle sur aaNbBnvlJur*/
  private ctrlA102: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaNbBnvlJur = control.get('aaNbBnvlJur').value;
    const aaAssoNbBnvlJur = control.get('aaAssoNbBnvlJur').value;

    if (aaNbBnvlJur !== null && aaAssoNbBnvlJur !== null && Number(aaNbBnvlJur) > Number(aaAssoNbBnvlJur)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA102': { value: control.value } } : null;
  }
  /* controle sur aaEtpBnvlJur*/
  private ctrlA45: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaEtpBnvlJur = control.get("aaEtpBnvlJur").value;
    const aaEtpBnvlJur_float = parseFloat(control.get("aaEtpBnvlJur").value) || 0;
    const aaAssoEtpBnvlJur = control.get("aaAssoEtpBnvlJur").value;
    const aaAssoEtpBnvlJur_float = parseFloat(control.get("aaAssoEtpBnvlJur").value) || 0;

    if (aaEtpBnvlJur !== null && aaEtpBnvlJur !== '' && aaAssoEtpBnvlJur !== null && aaAssoEtpBnvlJur !== '' && parseFloat(aaEtpBnvlJur_float.toFixed(2)) > parseFloat(aaAssoEtpBnvlJur_float.toFixed(2))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA45': { value: control.value } } : null;
  }
  /* controle sur aaNbBnvlPsy*/
  private ctrlA46: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaNbBnvlPsy = control.get('aaNbBnvlPsy').value;
    const aaAssoNbBnvlPsy = control.get('aaAssoNbBnvlPsy').value;

    if (aaNbBnvlPsy !== null && aaAssoNbBnvlPsy !== null && Number(aaNbBnvlPsy) > Number(aaAssoNbBnvlPsy)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA46': { value: control.value } } : null;
  }
  /* controle sur aaEtpBnvlPsy*/
  private ctrlA47: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaEtpBnvlPsy = control.get("aaEtpBnvlPsy").value;
    const aaEtpBnvlPsy_float = parseFloat(control.get("aaEtpBnvlPsy").value) || 0;
    const aaAssoEtpBnvlPsy = control.get("aaAssoEtpBnvlPsy").value;
    const aaAssoEtpBnvlPsy_float = parseFloat(control.get("aaAssoEtpBnvlPsy").value) || 0;

    if (aaEtpBnvlPsy !== null && aaEtpBnvlPsy !== '' && aaAssoEtpBnvlPsy !== null && aaAssoEtpBnvlPsy !== '' && parseFloat(aaEtpBnvlPsy_float.toFixed(2)) > parseFloat(aaAssoEtpBnvlPsy_float.toFixed(2))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA47': { value: control.value } } : null;
  }
  /* controle sur aaNbBnvlWsoc*/
  private ctrlA48: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaNbBnvlWsoc = control.get('aaNbBnvlWsoc').value;
    const aaAssoNbBnvlWsoc = control.get('aaAssoNbBnvlWsoc').value;

    if (aaNbBnvlWsoc !== null && aaAssoNbBnvlWsoc !== null && Number(aaNbBnvlWsoc) > Number(aaAssoNbBnvlWsoc)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA48': { value: control.value } } : null;
  }
  /* controle sur aaEtpBnvlWsoc*/
  private ctrlA49: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaEtpBnvlWsoc = control.get("aaEtpBnvlWsoc").value;
    const aaEtpBnvlWsoc_float = parseFloat(control.get("aaEtpBnvlWsoc").value) || 0;
    const aaAssoEtpBnvlWsoc_float = parseFloat(control.get("aaAssoEtpBnvlWsoc").value) || 0;
    const aaAssoEtpBnvlWsoc = control.get("aaAssoEtpBnvlWsoc").value;

    if (aaEtpBnvlWsoc !== null && aaEtpBnvlWsoc !== '' && aaAssoEtpBnvlWsoc !== null && aaAssoEtpBnvlWsoc !== '' && parseFloat(aaEtpBnvlWsoc_float.toFixed(2)) > parseFloat(aaAssoEtpBnvlWsoc_float.toFixed(2))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA49': { value: control.value } } : null;
  }
  /* controle sur aaNbBnvlTot*/
  private ctrlA15: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaNbBnvlTot = control.get('aaNbBnvlTot').value;
    const aaNbBnvlAav = Number(control.get('aaNbBnvlAav').value);
    const aaNbBnvlJur = Number(control.get('aaNbBnvlJur').value);
    const aaNbBnvlPsy = Number(control.get('aaNbBnvlPsy').value);
    const aaNbBnvlWsoc = Number(control.get('aaNbBnvlWsoc').value);
    const aaNbBnvlAutrInterv = Number(control.get('aaNbBnvlAutrInterv').value);
    const aaNbBnvlDir = Number(control.get('aaNbBnvlDir').value);
    const aaNbBnvlComptsecr = Number(control.get('aaNbBnvlComptsecr').value);
    const aaNbBnvlAutrSupport = Number(control.get('aaNbBnvlAutrSupport').value);

    if (aaNbBnvlTot === null && aaNbBnvlAav === 0 && aaNbBnvlJur === 0 && aaNbBnvlPsy === 0 && aaNbBnvlWsoc === 0 && aaNbBnvlAutrInterv === 0 && aaNbBnvlDir === 0 && aaNbBnvlComptsecr === 0 && aaNbBnvlAutrSupport === 0) {
      resultat = false;
    } else {
      if (aaNbBnvlTot !== null && Number(aaNbBnvlTot) < (aaNbBnvlAav + aaNbBnvlJur + aaNbBnvlPsy + aaNbBnvlWsoc + aaNbBnvlAutrInterv + aaNbBnvlDir + aaNbBnvlComptsecr + aaNbBnvlAutrSupport)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlA15': { value: control.value } } : null;
  }
  /* controle sur aaNbBnvlTot*/
  private ctrlA50: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaNbBnvlTot = control.get('aaNbBnvlTot').value;
    const aaAssoNbBnvl = control.get('aaAssoNbBnvl').value;

    if (aaNbBnvlTot !== null && aaAssoNbBnvl !== null && Number(aaNbBnvlTot) > Number(aaAssoNbBnvl)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA50': { value: control.value } } : null;
  }
  /* controle sur aaEtpBnvlTot*/
  private ctrlA16: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaEtpBnvlTot = control.get("aaEtpBnvlTot").value;
    const aaEtpBnvlTot_float = parseFloat(control.get("aaEtpBnvlTot").value) || 0;
    const aaEtpBnvlAav = parseFloat(control.get("aaEtpBnvlAav").value) || 0;
    const aaEtpBnvlJur = parseFloat(control.get("aaEtpBnvlJur").value) || 0;
    const aaEtpBnvlPsy = parseFloat(control.get("aaEtpBnvlPsy").value) || 0;
    const aaEtpBnvlWsoc = parseFloat(control.get("aaEtpBnvlWsoc").value) || 0;
    const aaEtpBnvlAutrInterv = parseFloat(control.get("aaEtpBnvlAutrInterv").value) || 0;
    const aaEtpBnvlDir = parseFloat(control.get("aaEtpBnvlDir").value) || 0;
    const aaEtpBnvlComptsecr = parseFloat(control.get("aaEtpBnvlComptsecr").value) || 0;
    const aaEtpBnvlAutrSupport = parseFloat(control.get("aaEtpBnvlAutrSupport").value) || 0;
    // Pour ces variables décimales ETPT, le FloatInputComponent manipule les nombres décimaux
    // en virgule flottante avec 3 décimales après le séparateur décimal, alors qu'on souhaite seulement
    // 2 décimales dans l'interface et côté API, conformément à la spécification.
    // On cherche à comparer ces nombres décimaux en virgule flottante limités à 2 décimales
    // et non pas des string qui sont comparées selon les valeurs des codes Unicode des
    // caractères qu'elles contiennent : les number 11.11 > 2.22, mais les string '11.11' < '2.22'
    // Or la méthode toFixed(2) sur un number renvoie une string et non pas un number. A partir de la string
    // formatée par toFixed(2), il faut donc utiliser parseFloat() pour manipuler de nouveau un number.

    const sommeTableau = (aaEtpBnvlAav + aaEtpBnvlJur + aaEtpBnvlPsy + aaEtpBnvlWsoc + aaEtpBnvlAutrInterv + aaEtpBnvlDir + aaEtpBnvlComptsecr + aaEtpBnvlAutrSupport);

    if (aaEtpBnvlTot !== null && aaEtpBnvlTot !== '' && (parseFloat(aaEtpBnvlTot_float.toFixed(2)) < parseFloat(sommeTableau.toFixed(2)))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA16': { value: control.value } } : null;
  }
  /* controle sur aaEtpBnvlTot*/
  private ctrlA51: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaEtpBnvlTot = control.get("aaEtpBnvlTot").value;
    const aaEtpBnvlTot_float = parseFloat(control.get("aaEtpBnvlTot").value) || 0;
    const aaAssoEtpBnvl = control.get("aaAssoEtpBnvl").value;
    const aaAssoEtpBnvl_float = parseFloat(control.get("aaAssoEtpBnvl").value) || 0;

    if (aaEtpBnvlTot !== null && aaEtpBnvlTot !== '' && aaAssoEtpBnvl !== null && aaAssoEtpBnvl !== '' && parseFloat(aaEtpBnvlTot_float.toFixed(2)) > parseFloat(aaAssoEtpBnvl_float.toFixed(2))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA51': { value: control.value } } : null;
  }

  // Contrôles sur les lieux de permanence (boucle) de l'onglet Moyens : l'appel des contrôles est fait dans chaque component.ts de chaque boucle (ex lieuxAsso ...), car pas sur rootform général
  /* controle sur aaLieuAssoNbPerm*/
  public ctrlA60Asso: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaLieuAssoNbPerm = control.get('aaLieuAssoNbPerm').value;

    if (aaLieuAssoNbPerm !== null && Number(aaLieuAssoNbPerm) > 730) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA60Asso': { value: control.value } } : null;
  }
  /* controle sur aaLieuAssoNbPermEtp*/
  public ctrlA61Asso: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaLieuAssoNbPerm = control.get('aaLieuAssoNbPerm').value;
    const aaLieuAssoNbPermEtp = control.get('aaLieuAssoNbPermEtp').value;

    if (aaLieuAssoNbPermEtp !== null && aaLieuAssoNbPerm !== null && Number(aaLieuAssoNbPermEtp) < Number(aaLieuAssoNbPerm)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA61Asso': { value: control.value } } : null;
  }
  /* controle sur aaLieuTjNbPerm*/
  public ctrlA62Tj: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaLieuTjNbPerm = control.get('aaLieuTjNbPerm').value;

    if (aaLieuTjNbPerm !== null && Number(aaLieuTjNbPerm) > 730) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA62Tj': { value: control.value } } : null;
  }
  /* controle sur aaLieuTjNbPermEtp*/
  public ctrlA63Tj: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaLieuTjNbPerm = control.get('aaLieuTjNbPerm').value;
    const aaLieuTjNbPermEtp = control.get('aaLieuTjNbPermEtp').value;

    if (aaLieuTjNbPermEtp !== null && aaLieuTjNbPerm !== null && Number(aaLieuTjNbPermEtp) < Number(aaLieuTjNbPerm)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA63Tj': { value: control.value } } : null;
  }
  /* controle sur aaLieuBavNbPerm*/
  public ctrlA64Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaLieuBavNbPerm = control.get('aaLieuBavNbPerm').value;

    if (aaLieuBavNbPerm !== null && Number(aaLieuBavNbPerm) > 730) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA64Bav': { value: control.value } } : null;
  }
  /* controle sur aaLieuBavNbPermEtp*/
  public ctrlA65Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaLieuBavNbPerm = control.get('aaLieuBavNbPerm').value;
    const aaLieuBavNbPermEtp = control.get('aaLieuBavNbPermEtp').value;

    if (aaLieuBavNbPermEtp !== null && aaLieuBavNbPerm !== null && Number(aaLieuBavNbPermEtp) < Number(aaLieuBavNbPerm)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA65Bav': { value: control.value } } : null;
  }
  /* controle sur aaLieuPolgendNbPerm*/
  public ctrlA66Polgend: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaLieuPolgendNbPerm = control.get('aaLieuPolgendNbPerm').value;

    if (aaLieuPolgendNbPerm !== null && Number(aaLieuPolgendNbPerm) > 730) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA66Polgend': { value: control.value } } : null;
  }
  /* controle sur aaLieuPolgendNbPermEtp*/
  public ctrlA67Polgend: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaLieuPolgendNbPerm = control.get('aaLieuPolgendNbPerm').value;
    const aaLieuPolgendNbPermEtp = control.get('aaLieuPolgendNbPermEtp').value;

    if (aaLieuPolgendNbPermEtp !== null && aaLieuPolgendNbPerm !== null && Number(aaLieuPolgendNbPermEtp) < Number(aaLieuPolgendNbPerm)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA67Polgend': { value: control.value } } : null;
  }
  /* controle sur aaLieuFrservNbPerm*/
  public ctrlA68Frserv: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaLieuFrservNbPerm = control.get('aaLieuFrservNbPerm').value;

    if (aaLieuFrservNbPerm !== null && Number(aaLieuFrservNbPerm) > 730) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA68Frserv': { value: control.value } } : null;
  }
  /* controle sur aaLieuFrservNbPermEtp*/
  public ctrlA69Frserv: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaLieuFrservNbPerm = control.get('aaLieuFrservNbPerm').value;
    const aaLieuFrservNbPermEtp = control.get('aaLieuFrservNbPermEtp').value;

    if (aaLieuFrservNbPermEtp !== null && aaLieuFrservNbPerm !== null && Number(aaLieuFrservNbPermEtp) < Number(aaLieuFrservNbPerm)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA69Frserv': { value: control.value } } : null;
  }
  /* controle sur aaLieuSadNbPerm*/
  public ctrlA70Sad: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaLieuSadNbPerm = control.get('aaLieuSadNbPerm').value;

    if (aaLieuSadNbPerm !== null && Number(aaLieuSadNbPerm) > 730) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA70Sad': { value: control.value } } : null;
  }
  /* controle sur aaLieuSadNbPermEtp*/
  public ctrlA71Sad: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaLieuSadNbPerm = control.get('aaLieuSadNbPerm').value;
    const aaLieuSadNbPermEtp = control.get('aaLieuSadNbPermEtp').value;

    if (aaLieuSadNbPermEtp !== null && aaLieuSadNbPerm !== null && Number(aaLieuSadNbPermEtp) < Number(aaLieuSadNbPerm)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA71Sad': { value: control.value } } : null;
  }
  /* controle sur aaLieuHostoNbPerm*/
  public ctrlA72Hosto: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaLieuHostoNbPerm = control.get('aaLieuHostoNbPerm').value;

    if (aaLieuHostoNbPerm !== null && Number(aaLieuHostoNbPerm) > 730) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA72Hosto': { value: control.value } } : null;
  }
  /* controle sur aaLieuHostoNbPermEtp*/
  public ctrlA73Hosto: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaLieuHostoNbPerm = control.get('aaLieuHostoNbPerm').value;
    const aaLieuHostoNbPermEtp = control.get('aaLieuHostoNbPermEtp').value;

    if (aaLieuHostoNbPermEtp !== null && aaLieuHostoNbPerm !== null && Number(aaLieuHostoNbPermEtp) < Number(aaLieuHostoNbPerm)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA73Hosto': { value: control.value } } : null;
  }
  /* controle sur aaLieuColterNbPerm*/
  public ctrlA74Colter: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaLieuColterNbPerm = control.get('aaLieuColterNbPerm').value;

    if (aaLieuColterNbPerm !== null && Number(aaLieuColterNbPerm) > 730) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA74Colter': { value: control.value } } : null;
  }
  /* controle sur aaLieuColterNbPermEtp*/
  public ctrlA75Colter: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaLieuColterNbPerm = control.get('aaLieuColterNbPerm').value;
    const aaLieuColterNbPermEtp = control.get('aaLieuColterNbPermEtp').value;

    if (aaLieuColterNbPermEtp !== null && aaLieuColterNbPerm !== null && Number(aaLieuColterNbPermEtp) < Number(aaLieuColterNbPerm)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA75Colter': { value: control.value } } : null;
  }
  /* controle sur aaLieuAutrNbPerm*/
  public ctrlA76Autr: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaLieuAutrNbPerm = control.get('aaLieuAutrNbPerm').value;

    if (aaLieuAutrNbPerm !== null && Number(aaLieuAutrNbPerm) > 730) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA76Autr': { value: control.value } } : null;
  }
  /* controle sur aaLieuAutrNbPermEtp*/
  public ctrlA77Autr: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaLieuAutrNbPerm = control.get('aaLieuAutrNbPerm').value;
    const aaLieuAutrNbPermEtp = control.get('aaLieuAutrNbPermEtp').value;

    if (aaLieuAutrNbPermEtp !== null && aaLieuAutrNbPerm !== null && Number(aaLieuAutrNbPermEtp) < Number(aaLieuAutrNbPerm)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA77Autr': { value: control.value } } : null;
  }
  /* controle sur aaLieuNbTot*/
  private ctrlA103: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaLieuNbTot = Number(control.get('aaLieuNbTot').value);

    if (aaLieuNbTot === 0) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA103': { value: control.value } } : null;
  }
  /* controle sur aaServiDispoUrge*/
  private ctrlA104: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const aaServiDispoUrge = control.get('aaServiDispoUrge').value;
    const aaServiDispoUrgeNuit = control.get('aaServiDispoUrgeNuit').value;
    const aaServiDispoUrgeWe = control.get('aaServiDispoUrgeWe').value;
    const aaServiDispoUrgeFerie = control.get('aaServiDispoUrgeFerie').value;
    const aaServiDispoUrgeAutr = control.get('aaServiDispoUrgeAutr').value;

    if (aaServiDispoUrge === '1' && aaServiDispoUrgeNuit === '0' && aaServiDispoUrgeWe === '0' && aaServiDispoUrgeFerie === '0' && aaServiDispoUrgeAutr === '0') {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlA104': { value: control.value } } : null;
  }

  /*** Controles sur Premiers Contacts ***/
  /***************************************/
  /* controle sur bbPremContactOrigTot */
  private ctrlB1: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bbPremContactOrigTot = control.get('bbPremContactOrigTot').value;
    const bbPremContactOrigAsso = Number(control.get('bbPremContactOrigAsso').value);
    const bbPremContactOrigPerso = Number(control.get('bbPremContactOrigPerso').value);

    if (bbPremContactOrigTot === null && bbPremContactOrigAsso === 0 && bbPremContactOrigPerso === 0) {
      resultat = false;
    } else {
      if (bbPremContactOrigTot !== null && Number(bbPremContactOrigTot) < (bbPremContactOrigAsso + bbPremContactOrigPerso)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlB1': { value: control.value } } : null;
  }
  /* controle sur bbPremContactOrigTot */
  private ctrlB4: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bbPremContactOrigTot = control.get('bbPremContactOrigTot').value;
    const xxPremContactTot = control.root.get('dg').get('xxPremContactTot').value;

    if (bbPremContactOrigTot !== null && xxPremContactTot !== null && Number(bbPremContactOrigTot) !== Number(xxPremContactTot)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlB4': { value: control.value } } : null;
  }
  /* controle sur bbPremContactModeTot */
  private ctrlB2: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bbPremContactModeTot = control.get('bbPremContactModeTot').value;
    const bbPremContactModeEcrit = Number(control.get('bbPremContactModeEcrit').value);
    const bbPremContactModeTel = Number(control.get('bbPremContactModeTel').value);
    const bbPremContactModePres = Number(control.get('bbPremContactModePres').value);

    if (bbPremContactModeTot === null && bbPremContactModeEcrit === 0 && bbPremContactModeTel === 0 && bbPremContactModePres === 0) {
      resultat = false;
    } else {
      if (bbPremContactModeTot !== null && Number(bbPremContactModeTot) < (bbPremContactModeEcrit + bbPremContactModeTel + bbPremContactModePres)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlB2': { value: control.value } } : null;
  }
  /* controle sur bbPremContactModeTot */
  private ctrlB5: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bbPremContactModeTot = control.get('bbPremContactModeTot').value;
    const xxPremContactTot = control.root.get('dg').get('xxPremContactTot').value;

    if (bbPremContactModeTot !== null && xxPremContactTot !== null && Number(bbPremContactModeTot) !== Number(xxPremContactTot)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlB5': { value: control.value } } : null;
  }

  /* controle sur bbPremContactOrientTot */
  private ctrlB3: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bbPremContactOrientTot = control.get('bbPremContactOrientTot').value;
    const bbPremContactOrientProc = Number(control.get('bbPremContactOrientProc').value);
    const bbPremContactOrientAutjud = Number(control.get('bbPremContactOrientAutjud').value);
    const bbPremContactOrientPenit = Number(control.get('bbPremContactOrientPenit').value);
    const bbPremContactOrientPolgend = Number(control.get('bbPremContactOrientPolgend').value);
    const bbPremContactOrientUmj = Number(control.get('bbPremContactOrientUmj').value);
    const bbPremContactOrientHosto = Number(control.get('bbPremContactOrientHosto').value);
    const bbPremContactOrientColter = Number(control.get('bbPremContactOrientColter').value);
    const bbPremContactOrientAsso = Number(control.get('bbPremContactOrientAsso').value);
    const bbPremContactOrientSad = Number(control.get('bbPremContactOrientSad').value);
    const bbPremContactOrientPftel = Number(control.get('bbPremContactOrientPftel').value);
    const bbPremContactOrientFrvict = Number(control.get('bbPremContactOrientFrvict').value);
    const bbPremContactOrientPart = Number(control.get('bbPremContactOrientPart').value);
    const bbPremContactOrientPub = Number(control.get('bbPremContactOrientPub').value);
    const bbPremContactOrientRela = Number(control.get('bbPremContactOrientRela').value);
    const bbPremContactOrientAutr = Number(control.get('bbPremContactOrientAutr').value);

    if (bbPremContactOrientTot === null && bbPremContactOrientProc === 0 && bbPremContactOrientAutjud === 0 && bbPremContactOrientPenit === 0
      && bbPremContactOrientPolgend === 0 && bbPremContactOrientUmj === 0 && bbPremContactOrientHosto === 0
      && bbPremContactOrientColter === 0 && bbPremContactOrientAsso === 0 && bbPremContactOrientSad === 0
      && bbPremContactOrientPftel === 0 && bbPremContactOrientFrvict === 0 && bbPremContactOrientPart === 0
      && bbPremContactOrientPub === 0 && bbPremContactOrientRela === 0 && bbPremContactOrientAutr === 0
    ) {
      resultat = false;
    } else {
      if (bbPremContactOrientTot !== null && Number(bbPremContactOrientTot) < (bbPremContactOrientProc + bbPremContactOrientAutjud + bbPremContactOrientPenit + bbPremContactOrientPolgend
        + bbPremContactOrientUmj + bbPremContactOrientHosto + bbPremContactOrientColter + bbPremContactOrientAsso
        + bbPremContactOrientSad + bbPremContactOrientPftel + bbPremContactOrientFrvict + bbPremContactOrientPart
        + bbPremContactOrientPub + bbPremContactOrientRela + bbPremContactOrientAutr)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlB3': { value: control.value } } : null;
  }
  /* controle sur bbPremContactOrientTot */
  private ctrlB6: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bbPremContactOrientTot = control.get('bbPremContactOrientTot').value;
    const xxPremContactVictTot = control.root.get('dg').get('xxPremContactVictTot').value;

    if (bbPremContactOrientTot !== null && xxPremContactVictTot !== null && Number(bbPremContactOrientTot) !== Number(xxPremContactVictTot)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlB6': { value: control.value } } : null;
  }

  /*** Controles sur Personnes Recues ****/
  /***************************************/
  /* controle sur ccRecuVictNb */
  private ctrlC17: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ccRecuVictNb = control.get('ccRecuVictNb').value;
    const xxRecuVict = control.root.get('dg').get('xxRecuVict').value;

    if (ccRecuVictNb !== null && xxRecuVict !== null && Number(ccRecuVictNb) !== Number(xxRecuVict)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlC17': { value: control.value } } : null;
  }
  /* controle sur ccRecuNvictNb */
  private ctrlC18: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ccRecuNvictNb = control.get('ccRecuNvictNb').value;
    const xxRecuNvict = control.root.get('dg').get('xxRecuNvict').value;

    if (ccRecuNvictNb !== null && xxRecuNvict !== null && Number(ccRecuNvictNb) !== Number(xxRecuNvict)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlC18': { value: control.value } } : null;
  }
  /* controle sur ccRecuNbTot */
  private ctrlC1: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ccRecuNbTot = control.get('ccRecuNbTot').value;
    const ccRecuVictNb = Number(control.get('ccRecuVictNb').value);
    const ccRecuNvictNb = Number(control.get('ccRecuNvictNb').value);

    if (ccRecuNbTot === null && ccRecuVictNb === 0 && ccRecuNvictNb === 0) {
      resultat = false;
    } else {
      if (ccRecuNbTot !== null && Number(ccRecuNbTot) < (ccRecuVictNb + ccRecuNvictNb)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlC1': { value: control.value } } : null;
  }
  /* controle sur ccRecuNbTot */
  private ctrlC19: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ccRecuNbTot = control.get('ccRecuNbTot').value;
    const xxRecuTot = control.root.get('dg').get('xxRecuTot').value;

    if (ccRecuNbTot !== null && xxRecuTot !== null && Number(ccRecuNbTot) !== Number(xxRecuTot)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlC19': { value: control.value } } : null;
  }
  /* controle sur ccRecuVictSuivi */
  private ctrlC11: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ccRecuVictSuivi = control.get('ccRecuVictSuivi').value;
    const ccRecuVictNb = control.get('ccRecuVictNb').value;

    if (ccRecuVictSuivi !== null && ccRecuVictNb !== null && Number(ccRecuVictSuivi) > Number(ccRecuVictNb)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlC11': { value: control.value } } : null;
  }
  /* controle sur ccRecuNvictSuivi */
  private ctrlC12: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ccRecuNvictSuivi = control.get('ccRecuNvictSuivi').value;
    const ccRecuNvictNb = control.get('ccRecuNvictNb').value;

    if (ccRecuNvictSuivi !== null && ccRecuNvictNb !== null && Number(ccRecuNvictSuivi) > Number(ccRecuNvictNb)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlC12': { value: control.value } } : null;
  }
  /* controle sur ccRecuSuiviTot */
  private ctrlC2: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ccRecuSuiviTot = control.get('ccRecuSuiviTot').value;
    const ccRecuVictSuivi = Number(control.get('ccRecuVictSuivi').value);
    const ccRecuNvictSuivi = Number(control.get('ccRecuNvictSuivi').value);

    if (ccRecuSuiviTot === null && ccRecuVictSuivi === 0 && ccRecuNvictSuivi === 0) {
      resultat = false;
    } else {
      if (ccRecuSuiviTot !== null && Number(ccRecuSuiviTot) < (ccRecuVictSuivi + ccRecuNvictSuivi)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlC2': { value: control.value } } : null;
  }
  /* controle sur ccRecuSuiviTot */
  private ctrlC13: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ccRecuSuiviTot = control.get('ccRecuSuiviTot').value;
    const ccRecuNbTot = control.get('ccRecuNbTot').value;

    if (ccRecuSuiviTot !== null && ccRecuNbTot !== null && Number(ccRecuSuiviTot) > Number(ccRecuNbTot)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlC13': { value: control.value } } : null;
  }
  /* controle sur ccRecuVictEntret */
  private ctrlC14: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ccRecuVictEntret = control.get('ccRecuVictEntret').value;
    const ccRecuVictNb = control.get('ccRecuVictNb').value;

    if (ccRecuVictEntret !== null && ccRecuVictNb !== null && Number(ccRecuVictEntret) < Number(ccRecuVictNb)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlC14': { value: control.value } } : null;
  }
  /* controle sur ccRecuEntretTot */
  private ctrlC3: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ccRecuEntretTot = control.get('ccRecuEntretTot').value;
    const ccRecuVictEntret = Number(control.get('ccRecuVictEntret').value);
    const ccRecuNvictEntret = Number(control.get('ccRecuNvictEntret').value);

    if (ccRecuEntretTot === null && ccRecuVictEntret === 0 && ccRecuNvictEntret === 0) {
      resultat = false;
    } else {
      if (ccRecuEntretTot !== null && Number(ccRecuEntretTot) < (ccRecuVictEntret + ccRecuNvictEntret)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlC3': { value: control.value } } : null;
  }
  /* controle sur ccRecuEntretTot */
  private ctrlC16: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ccRecuEntretTot = control.get('ccRecuEntretTot').value;
    const ccRecuNbTot = control.get('ccRecuNbTot').value;

    if (ccRecuEntretTot !== null && ccRecuNbTot !== null && Number(ccRecuEntretTot) < Number(ccRecuNbTot)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlC16': { value: control.value } } : null;
  }
  /* controle sur ccVictMinTot */
  private ctrlC4: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ccVictMinTot = control.get('ccVictMinTot').value;
    const ccVictFemMin = Number(control.get('ccVictFemMin').value);
    const ccVictHomMin = Number(control.get('ccVictHomMin').value);

    if (ccVictMinTot === null && ccVictFemMin === 0 && ccVictHomMin === 0) {
      resultat = false;
    } else {
      if (ccVictMinTot !== null && Number(ccVictMinTot) < (ccVictFemMin + ccVictHomMin)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlC4': { value: control.value } } : null;
  }
  /* controle sur ccVictMajTot */
  private ctrlC5: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ccVictMajTot = control.get('ccVictMajTot').value;
    const ccVictFemMaj = Number(control.get('ccVictFemMaj').value);
    const ccVictHomMaj = Number(control.get('ccVictHomMaj').value);

    if (ccVictMajTot === null && ccVictFemMaj === 0 && ccVictHomMaj === 0) {
      resultat = false;
    } else {
      if (ccVictMajTot !== null && Number(ccVictMajTot) < (ccVictFemMaj + ccVictHomMaj)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlC5': { value: control.value } } : null;
  }
  /* controle sur ccVictSeniorTot */
  private ctrlC6: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ccVictSeniorTot = control.get('ccVictSeniorTot').value;
    const ccVictFemSenior = Number(control.get('ccVictFemSenior').value);
    const ccVictHomSenior = Number(control.get('ccVictHomSenior').value);

    if (ccVictSeniorTot === null && ccVictFemSenior === 0 && ccVictHomSenior === 0) {
      resultat = false;
    } else {
      if (ccVictSeniorTot !== null && Number(ccVictSeniorTot) < (ccVictFemSenior + ccVictHomSenior)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlC6': { value: control.value } } : null;
  }
  /* controle sur ccVictFemTot */
  private ctrlC7: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ccVictFemTot = control.get('ccVictFemTot').value;
    const ccVictFemMin = Number(control.get('ccVictFemMin').value);
    const ccVictFemMaj = Number(control.get('ccVictFemMaj').value);
    const ccVictFemSenior = Number(control.get('ccVictFemSenior').value);

    if (ccVictFemTot === null && ccVictFemMin === 0 && ccVictFemMaj === 0 && ccVictFemSenior === 0) {
      resultat = false;
    } else {
      if (ccVictFemTot !== null && Number(ccVictFemTot) < (ccVictFemMin + ccVictFemMaj + ccVictFemSenior)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlC7': { value: control.value } } : null;
  }
  /* controle sur ccVictHomTot */
  private ctrlC8: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ccVictHomTot = control.get('ccVictHomTot').value;
    const ccVictHomMin = Number(control.get('ccVictHomMin').value);
    const ccVictHomMaj = Number(control.get('ccVictHomMaj').value);
    const ccVictHomSenior = Number(control.get('ccVictHomSenior').value);

    if (ccVictHomTot === null && ccVictHomMin === 0 && ccVictHomMaj === 0 && ccVictHomSenior === 0) {
      resultat = false;
    } else {
      if (ccVictHomTot !== null && Number(ccVictHomTot) < (ccVictHomMin + ccVictHomMaj + ccVictHomSenior)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlC8': { value: control.value } } : null;
  }
  /* controle sur ccVictPpTot */
  private ctrlC25: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ccVictPpTot = control.get('ccVictPpTot').value;
    const ccVictFemTot = Number(control.get('ccVictFemTot').value);
    const ccVictHomTot = Number(control.get('ccVictHomTot').value);

    if (ccVictPpTot === null && ccVictFemTot === 0 && ccVictHomTot === 0) {
      resultat = false;
    } else {
      if (ccVictPpTot !== null && Number(ccVictPpTot) < (ccVictFemTot + ccVictHomTot)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlC25': { value: control.value } } : null;
  }
  /* controle sur ccVictTot */
  private ctrlC9: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ccVictTot = control.get('ccVictTot').value;
    const ccVictFemTot = Number(control.get('ccVictFemTot').value);
    const ccVictHomTot = Number(control.get('ccVictHomTot').value);
    const ccVictPm = Number(control.get('ccVictPm').value);

    if (ccVictTot === null && ccVictFemTot === 0 && ccVictHomTot === 0 && ccVictPm === 0) {
      resultat = false;
    } else {
      if (ccVictTot !== null && Number(ccVictTot) < (ccVictFemTot + ccVictHomTot + ccVictPm)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlC9': { value: control.value } } : null;
  }
  /* controle sur ccVictTot */
  private ctrlC20: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ccVictTot = control.get('ccVictTot').value;
    const xxRecuVict = control.root.get('dg').get('xxRecuVict').value;

    if (ccVictTot !== null && xxRecuVict !== null && Number(ccVictTot) !== Number(xxRecuVict)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlC20': { value: control.value } } : null;
  }
  /* controle sur ccTjVifTgdNbUrge */
  /* Controle sur boucle appelé dans saisieService lie au composant personnes recues => appel controle boucle different des autres controles */
  public ctrlC21Tj: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ccTjVifTgdNbUrge = control.get('ccTjVifTgdNbUrge').value;
    const ccTjVifTgdNb = control.get('ccTjVifTgdNb').value;

    if (ccTjVifTgdNbUrge !== null && ccTjVifTgdNb !== null && Number(ccTjVifTgdNbUrge) > Number(ccTjVifTgdNb)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlC21Tj': { value: control.value } } : null;
  }
  /* controle sur ccTjVifBarNbUrge */
  /* Controle sur boucle appelé dans saisieService lie au composant personnes recues => appel controle boucle different des autres controles */
  public ctrlC22Tj: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ccTjVifBarNbUrge = control.get('ccTjVifBarNbUrge').value;
    const ccTjVifBarNb = control.get('ccTjVifBarNb').value;

    if (ccTjVifBarNbUrge !== null && ccTjVifBarNb !== null && Number(ccTjVifBarNbUrge) > Number(ccTjVifBarNb)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlC22Tj': { value: control.value } } : null;
  }
  /* controle sur ccRestauMesureTot */
  private ctrlC10: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ccRestauMesureTot = control.get('ccRestauMesureTot').value;
    const ccRestauMesureRdv = Number(control.get('ccRestauMesureRdv').value);
    const ccRestauMesureRcv = Number(control.get('ccRestauMesureRcv').value);
    const ccRestauMesureMr = Number(control.get('ccRestauMesureMr').value);
    const ccRestauMesureCr = Number(control.get('ccRestauMesureCr').value);
    const ccRestauMesureCercle = Number(control.get('ccRestauMesureCercle').value);
    const ccRestauMesureCsr = Number(control.get('ccRestauMesureCsr').value);
    const ccRestauMesureCar = Number(control.get('ccRestauMesureCar').value);

    if (ccRestauMesureTot === null && ccRestauMesureRdv === 0 && ccRestauMesureRcv === 0 && ccRestauMesureMr === 0 && ccRestauMesureCr === 0
      && ccRestauMesureCercle === 0 && ccRestauMesureCsr === 0 && ccRestauMesureCar === 0) {
      resultat = false;
    } else {
      if (ccRestauMesureTot !== null && Number(ccRestauMesureTot) < (ccRestauMesureRdv + ccRestauMesureRcv + ccRestauMesureMr + ccRestauMesureCr
        + ccRestauMesureCercle + ccRestauMesureCsr + ccRestauMesureCar)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlC10': { value: control.value } } : null;
  }
  /* controle sur ccRestauMesureTot */
  private ctrlC23: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ccRestauMesureTot = control.get('ccRestauMesureTot').value;
    const ccRestauMesure = control.get('ccRestauMesure').value;

    if (ccRestauMesureTot !== null && ccRestauMesure !== null && Number(ccRestauMesureTot) !== Number(ccRestauMesure)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlC23': { value: control.value } } : null;
  }
  /* controle sur ccDispoPartAutr */
  private ctrlC24: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ccDispoPartAutr = control.get('ccDispoPartAutr').value;
    const ccDispoPartAutrContact = control.get('ccDispoPartAutrContact').value;
    const ccDispoPartAutrEntret = control.get('ccDispoPartAutrEntret').value;

    if (ccDispoPartAutr === '1' && ccDispoPartAutrContact === 0 && ccDispoPartAutrEntret === 0) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlC24': { value: control.value } } : null;
  }

  /*** Controles sur Contexte faits procedure ****/
  /***********************************************/
  /* controle sur ddFaitPersoTot */
  private ctrlD1: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ddFaitPersoTot = control.get('ddFaitPersoTot').value;
    const ddFaitPersoHomiVolo = Number(control.get('ddFaitPersoHomiVolo').value);
    const ddFaitPersoSexuel = Number(control.get('ddFaitPersoSexuel').value);
    const ddFaitPersoProxe = Number(control.get('ddFaitPersoProxe').value);
    const ddFaitPersoViolen = Number(control.get('ddFaitPersoViolen').value);
    const ddFaitPersoHomiInvolo = Number(control.get('ddFaitPersoHomiInvolo').value);
    const ddFaitPersoBless = Number(control.get('ddFaitPersoBless').value);
    const ddFaitPersoAband = Number(control.get('ddFaitPersoAband').value);
    const ddFaitPersoMenace = Number(control.get('ddFaitPersoMenace').value);
    const ddFaitPersoDiscri = Number(control.get('ddFaitPersoDiscri').value);
    const ddFaitPersoAutr = Number(control.get('ddFaitPersoAutr').value);

    if (ddFaitPersoTot === null && ddFaitPersoHomiVolo === 0 && ddFaitPersoSexuel === 0 && ddFaitPersoProxe === 0 && ddFaitPersoViolen === 0
      && ddFaitPersoHomiInvolo === 0 && ddFaitPersoBless === 0 && ddFaitPersoAband === 0 && ddFaitPersoMenace === 0
      && ddFaitPersoDiscri === 0 && ddFaitPersoAutr === 0) {
      resultat = false;
    } else {
      if (ddFaitPersoTot !== null && Number(ddFaitPersoTot) < (ddFaitPersoHomiVolo + ddFaitPersoSexuel + ddFaitPersoProxe + ddFaitPersoViolen
        + ddFaitPersoHomiInvolo + ddFaitPersoBless + ddFaitPersoAband + ddFaitPersoMenace + ddFaitPersoDiscri + ddFaitPersoAutr)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlD1': { value: control.value } } : null;
  }
  /* controle sur ddFaitBienTot */
  private ctrlD2: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ddFaitBienTot = control.get('ddFaitBienTot').value;
    const ddFaitBienVolSimp = Number(control.get('ddFaitBienVolSimp').value);
    const ddFaitBienVolAggr = Number(control.get('ddFaitBienVolAggr').value);
    const ddFaitBienEscro = Number(control.get('ddFaitBienEscro').value);
    const ddFaitBienDegrad = Number(control.get('ddFaitBienDegrad').value);
    const ddFaitBienAutr = Number(control.get('ddFaitBienAutr').value);

    if (ddFaitBienTot === null && ddFaitBienVolSimp === 0 && ddFaitBienVolAggr === 0 && ddFaitBienEscro === 0 && ddFaitBienDegrad === 0
      && ddFaitBienAutr === 0) {
      resultat = false;
    } else {
      if (ddFaitBienTot !== null && Number(ddFaitBienTot) < (ddFaitBienVolSimp + ddFaitBienVolAggr + ddFaitBienEscro + ddFaitBienDegrad
        + ddFaitBienAutr)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlD2': { value: control.value } } : null;
  }
  /* controle sur ddFaitCircuTot */
  private ctrlD3: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ddFaitCircuTot = control.get('ddFaitCircuTot').value;
    const ddFaitCircuBless = Number(control.get('ddFaitCircuBless').value);
    const ddFaitCircuDegat = Number(control.get('ddFaitCircuDegat').value);

    if (ddFaitCircuTot === null && ddFaitCircuBless === 0 && ddFaitCircuDegat === 0) {
      resultat = false;
    } else {
      if (ddFaitCircuTot !== null && Number(ddFaitCircuTot) < (ddFaitCircuBless + ddFaitCircuDegat)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlD3': { value: control.value } } : null;
  }
  /* controle sur ddFaitTot */
  private ctrlD4: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ddFaitTot = control.get('ddFaitTot').value;
    const ddFaitPersoTot = Number(control.get('ddFaitPersoTot').value);
    const ddFaitBienTot = Number(control.get('ddFaitBienTot').value);
    const ddFaitCircuTot = Number(control.get('ddFaitCircuTot').value);
    const ddFaitAutr = Number(control.get('ddFaitAutr').value);

    if (ddFaitTot === null && ddFaitPersoTot === 0 && ddFaitBienTot === 0 && ddFaitCircuTot === 0 && ddFaitAutr === 0) {
      resultat = false;
    } else {
      if (ddFaitTot !== null && Number(ddFaitTot) < (ddFaitPersoTot + ddFaitBienTot + ddFaitCircuTot + ddFaitAutr)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlD4': { value: control.value } } : null;
  }
  /* controle sur ddCadrePersoTot */
  private ctrlD5: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ddCadrePersoTot = control.get('ddCadrePersoTot').value;
    const ddCadrePersoCple = Number(control.get('ddCadrePersoCple').value);
    const ddCadrePersoFam = Number(control.get('ddCadrePersoFam').value);
    const ddCadrePersoPro = Number(control.get('ddCadrePersoPro').value);
    const ddCadrePersoScol = Number(control.get('ddCadrePersoScol').value);
    const ddCadrePersoSpor = Number(control.get('ddCadrePersoSpor').value);
    const ddCadrePersoRue = Number(control.get('ddCadrePersoRue').value);
    const ddCadrePersoAutr = Number(control.get('ddCadrePersoAutr').value);

    if (ddCadrePersoTot === null && ddCadrePersoCple === 0 && ddCadrePersoFam === 0 && ddCadrePersoPro === 0 && ddCadrePersoScol === 0
      && ddCadrePersoSpor === 0 && ddCadrePersoRue === 0 && ddCadrePersoAutr === 0
    ) {
      resultat = false;
    } else {
      if (ddCadrePersoTot !== null && Number(ddCadrePersoTot) < (ddCadrePersoCple + ddCadrePersoFam + ddCadrePersoPro + ddCadrePersoScol
        + ddCadrePersoSpor + ddCadrePersoRue + ddCadrePersoAutr)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlD5': { value: control.value } } : null;
  }
  /* controle sur ddCadreBienTot */
  private ctrlD6: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ddCadreBienTot = control.get('ddCadreBienTot').value;
    const ddCadreBienCple = Number(control.get('ddCadreBienCple').value);
    const ddCadreBienFam = Number(control.get('ddCadreBienFam').value);
    const ddCadreBienPro = Number(control.get('ddCadreBienPro').value);
    const ddCadreBienScol = Number(control.get('ddCadreBienScol').value);
    const ddCadreBienSpor = Number(control.get('ddCadreBienSpor').value);
    const ddCadreBienRue = Number(control.get('ddCadreBienRue').value);
    const ddCadreBienAutr = Number(control.get('ddCadreBienAutr').value);

    if (ddCadreBienTot === null && ddCadreBienCple === 0 && ddCadreBienFam === 0 && ddCadreBienPro === 0 && ddCadreBienScol === 0
      && ddCadreBienSpor === 0 && ddCadreBienRue === 0 && ddCadreBienAutr === 0
    ) {
      resultat = false;
    } else {
      if (ddCadreBienTot !== null && Number(ddCadreBienTot) < (ddCadreBienCple + ddCadreBienFam + ddCadreBienPro + ddCadreBienScol
        + ddCadreBienSpor + ddCadreBienRue + ddCadreBienAutr)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlD6': { value: control.value } } : null;
  }
  /* controle sur ddPlainteTot */
  private ctrlD7: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const ddPlainteTot = control.get('ddPlainteTot').value;
    const xxRecuVict = control.root.get('dg').get('xxRecuVict').value;

    if (ddPlainteTot !== null && xxRecuVict !== null && Number(ddPlainteTot) !== Number(xxRecuVict)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlD7': { value: control.value } } : null;
  }

  /*** Controles sur Aides apportées ****/
  /**************************************/
  /* controle sur eeEntretTot */
  private ctrlE1: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const eeEntretTot = control.get('eeEntretTot').value;
    const eeEntretPsy = Number(control.get('eeEntretPsy').value);
    const eeEntretJur = Number(control.get('eeEntretJur').value);
    const eeEntretSoc = Number(control.get('eeEntretSoc').value);
    const eeEntretEcout = Number(control.get('eeEntretEcout').value);
    const eeEntretAutr = Number(control.get('eeEntretAutr').value);

    if (eeEntretTot === null && eeEntretPsy === 0 && eeEntretJur === 0 && eeEntretSoc === 0 && eeEntretEcout === 0
      && eeEntretAutr === 0
    ) {
      resultat = false;
    } else {
      if (eeEntretTot !== null && Number(eeEntretTot) < (eeEntretPsy + eeEntretJur + eeEntretSoc + eeEntretEcout
        + eeEntretAutr)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlE1': { value: control.value } } : null;
  }
  /* controle sur eeDiliTot */
  private ctrlE2: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const eeDiliTot = control.get('eeDiliTot').value;
    const eeDiliJur = Number(control.get('eeDiliJur').value);
    const eeDiliCivi = Number(control.get('eeDiliCivi').value);
    const eeDiliFondGaran = Number(control.get('eeDiliFondGaran').value);
    const eeDiliSarvi = Number(control.get('eeDiliSarvi').value);
    const eeDiliPenit = Number(control.get('eeDiliPenit').value);
    const eeDiliPolgend = Number(control.get('eeDiliPolgend').value);
    const eeDiliAvoc = Number(control.get('eeDiliAvoc').value);
    const eeDiliHuis = Number(control.get('eeDiliHuis').value);
    const eeDiliOrgaSoc = Number(control.get('eeDiliOrgaSoc').value);
    const eeDiliColter = Number(control.get('eeDiliColter').value);
    const eeDiliPref = Number(control.get('eeDiliPref').value);
    const eeDiliOrgaLogt = Number(control.get('eeDiliOrgaLogt').value);
    const eeDiliHebgt = Number(control.get('eeDiliHebgt').value);
    const eeDiliHosto = Number(control.get('eeDiliHosto').value);
    const eeDiliAsso = Number(control.get('eeDiliAsso').value);
    const eeDiliAssur = Number(control.get('eeDiliAssur').value);
    const eeDiliSad = Number(control.get('eeDiliSad').value);
    const eeDiliFrserv = Number(control.get('eeDiliFrserv').value);
    const eeDiliAutr = Number(control.get('eeDiliAutr').value);

    if (eeDiliTot === null && eeDiliJur === 0 && eeDiliCivi === 0 && eeDiliFondGaran === 0
      && eeDiliSarvi === 0 && eeDiliPenit === 0 && eeDiliPolgend === 0 && eeDiliAvoc === 0
      && eeDiliHuis === 0 && eeDiliOrgaSoc === 0 && eeDiliColter === 0 && eeDiliPref === 0
      && eeDiliOrgaLogt === 0 && eeDiliHebgt === 0 && eeDiliHosto === 0 && eeDiliAsso === 0
      && eeDiliAssur === 0 && eeDiliSad === 0 && eeDiliFrserv === 0
      && eeDiliAutr === 0) {
      resultat = false;
    } else {
      if (eeDiliTot !== null && Number(eeDiliTot) < (eeDiliJur + eeDiliCivi + eeDiliFondGaran + eeDiliSarvi
        + eeDiliPenit + eeDiliPolgend + eeDiliAvoc + eeDiliHuis + eeDiliOrgaSoc + eeDiliColter + eeDiliPref
        + eeDiliOrgaLogt + eeDiliHebgt + eeDiliHosto + eeDiliAsso + eeDiliAssur + eeDiliSad + eeDiliFrserv
        + eeDiliAutr)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlE2': { value: control.value } } : null;
  }
  /* Controle sur eeDiliTgd */
  private ctrlE3: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const eeDiliTgd = control.get('eeDiliTgd').value;
    const eeDiliTot = control.get('eeDiliTot').value;

    if (eeDiliTgd !== null && eeDiliTot !== null && Number(eeDiliTgd) > Number(eeDiliTot)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlE3': { value: control.value } } : null;
  }
  /* Controle sur eeDiliBar */
  private ctrlE4: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const eeDiliBar = control.get('eeDiliBar').value;
    const eeDiliTot = control.get('eeDiliTot').value;

    if (eeDiliBar !== null && eeDiliTot !== null && Number(eeDiliBar) > Number(eeDiliTot)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlE4': { value: control.value } } : null;
  }
  /* Controle sur eeAideCivi */
  private ctrlE5: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const eeAideCivi = control.get('eeAideCivi').value;
    const xxRecuVict = control.root.get('dg').get('xxRecuVict').value;

    if (eeAideCivi !== null && xxRecuVict !== null && Number(eeAideCivi) > Number(xxRecuVict)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlE5': { value: control.value } } : null;
  }
  /* Controle sur eeAideSarvi */
  private ctrlE6: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const eeAideSarvi = control.get('eeAideSarvi').value;
    const xxRecuVict = control.root.get('dg').get('xxRecuVict').value;

    if (eeAideSarvi !== null && xxRecuVict !== null && Number(eeAideSarvi) > Number(xxRecuVict)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlE6': { value: control.value } } : null;
  }
  /*** Controles sur BAV ****/
  /* C'est une boucle l'appel des fonctions est faite dans le component ts (et inclus dans saisieService) */
  /********************************************************************************************************/
  /* controle sur bavAaNbTot */
  public ctrlF1Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavAaNbTot = control.get('bavAaNbTot').value;
    const bavAaNbAav = Number(control.get('bavAaNbAav').value);
    const bavAaNbJur = Number(control.get('bavAaNbJur').value);
    const bavAaNbPsy = Number(control.get('bavAaNbPsy').value);
    const bavAaNbWsoc = Number(control.get('bavAaNbWsoc').value);
    const bavAaNbAutrInterv = Number(control.get('bavAaNbAutrInterv').value);
    const bavAaNbDir = Number(control.get('bavAaNbDir').value);
    const bavAaNbComptsecr = Number(control.get('bavAaNbComptsecr').value);
    const bavAaNbAutrSupport = Number(control.get('bavAaNbAutrSupport').value);

    if (bavAaNbTot === null && bavAaNbAav === 0 && bavAaNbJur === 0 && bavAaNbPsy === 0 && bavAaNbWsoc === 0
      && bavAaNbAutrInterv === 0 && bavAaNbDir === 0 && bavAaNbComptsecr === 0 && bavAaNbAutrSupport === 0
    ) {
      resultat = false;
    } else {
      if (bavAaNbTot !== null && Number(bavAaNbTot) < (bavAaNbAav + bavAaNbJur + bavAaNbPsy + bavAaNbWsoc
        + bavAaNbAutrInterv + bavAaNbDir + bavAaNbComptsecr + bavAaNbAutrSupport)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlF1Bav': { value: control.value } } : null;
  }
  /* controle sur bavAaEtpTot */
  public ctrlF2Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavAaEtpTot = control.get("bavAaEtpTot").value;
    const bavAaEtpTot_float = parseFloat(control.get("bavAaEtpTot").value) || 0;
    const bavAaEtpAav = parseFloat(control.get("bavAaEtpAav").value) || 0;
    const bavAaEtpJur = parseFloat(control.get("bavAaEtpJur").value) || 0;
    const bavAaEtpPsy = parseFloat(control.get("bavAaEtpPsy").value) || 0;
    const bavAaEtpWsoc = parseFloat(control.get("bavAaEtpWsoc").value) || 0;
    const bavAaEtpAutrInterv = parseFloat(control.get("bavAaEtpAutrInterv").value) || 0;
    const bavAaEtpDir = parseFloat(control.get("bavAaEtpDir").value) || 0;
    const bavAaEtpComptsecr = parseFloat(control.get("bavAaEtpComptsecr").value) || 0;
    const bavAaEtpAutrSupport = parseFloat(control.get("bavAaEtpAutrSupport").value) || 0;

    // Pour ces variables décimales ETPT, le FloatInputComponent manipule les nombres décimaux
    // en virgule flottante avec 3 décimales après le séparateur décimal, alors qu'on souhaite seulement
    // 2 décimales dans l'interface et côté API, conformément à la spécification.
    // On cherche à comparer ces nombres décimaux en virgule flottante limités à 2 décimales
    // et non pas des string qui sont comparées selon les valeurs des codes Unicode des
    // caractères qu'elles contiennent : les number 11.11 > 2.22, mais les string '11.11' < '2.22'
    // Or la méthode toFixed(2) sur un number renvoie une string et non pas un number. A partir de la string
    // formatée par toFixed(2), il faut donc utiliser parseFloat() pour manipuler de nouveau un number.

    const sommeTableau = (bavAaEtpAav + bavAaEtpJur + bavAaEtpPsy + bavAaEtpWsoc + bavAaEtpAutrInterv + bavAaEtpDir + bavAaEtpComptsecr + bavAaEtpAutrSupport);

    if (bavAaEtpTot !== null && bavAaEtpTot !== '' && parseFloat(bavAaEtpTot_float.toFixed(2)) < parseFloat(sommeTableau.toFixed(2))) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlF2Bav': { value: control.value } } : null;
  }
  /* controle sur bavBbPremContactOrigTot */
  public ctrlF3Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavBbPremContactOrigTot = control.get('bavBbPremContactOrigTot').value;
    const bavBbPremContactOrigAsso = Number(control.get('bavBbPremContactOrigAsso').value);
    const bavBbPremContactOrigPerso = Number(control.get('bavBbPremContactOrigPerso').value);

    if (bavBbPremContactOrigTot === null && bavBbPremContactOrigAsso === 0 && bavBbPremContactOrigPerso === 0) {
      resultat = false;
    } else {
      if (bavBbPremContactOrigTot !== null && Number(bavBbPremContactOrigTot) < (bavBbPremContactOrigAsso + bavBbPremContactOrigPerso)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlF3Bav': { value: control.value } } : null;
  }
  /* controle sur bavBbPremContactModeTot */
  public ctrlF4Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavBbPremContactModeTot = control.get('bavBbPremContactModeTot').value;
    const bavBbPremContactModeEcrit = Number(control.get('bavBbPremContactModeEcrit').value);
    const bavBbPremContactModeTel = Number(control.get('bavBbPremContactModeTel').value);
    const bavBbPremContactModePres = Number(control.get('bavBbPremContactModePres').value);

    if (bavBbPremContactModeTot === null && bavBbPremContactModeEcrit === 0 && bavBbPremContactModeTel === 0 && bavBbPremContactModePres === 0) {
      resultat = false;
    } else {
      if (bavBbPremContactModeTot !== null && Number(bavBbPremContactModeTot) < (bavBbPremContactModeEcrit + bavBbPremContactModeTel + bavBbPremContactModePres)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlF4Bav': { value: control.value } } : null;
  }
  /* controle sur bavBbPremContactModeTot */
  public ctrlF23Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavBbPremContactModeTot = control.get('bavBbPremContactModeTot').value;
    const bavBbPremContactOrigTot = control.get('bavBbPremContactOrigTot').value;

    if (bavBbPremContactModeTot !== null && bavBbPremContactOrigTot !== null && Number(bavBbPremContactModeTot) !== Number(bavBbPremContactOrigTot)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlF23Bav': { value: control.value } } : null;
  }
  /* controle sur bavCcRecuNbTot */
  public ctrlF5Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavCcRecuNbTot = control.get('bavCcRecuNbTot').value;
    const bavCcRecuVictNb = Number(control.get('bavCcRecuVictNb').value);
    const bavCcRecuNvictNb = Number(control.get('bavCcRecuNvictNb').value);

    if (bavCcRecuNbTot === null && bavCcRecuVictNb === 0 && bavCcRecuNvictNb === 0) {
      resultat = false;
    } else {
      if (bavCcRecuNbTot !== null && Number(bavCcRecuNbTot) < (bavCcRecuVictNb + bavCcRecuNvictNb)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlF5Bav': { value: control.value } } : null;
  }
  /* controle sur bavCcRecuVictSuivi */
  public ctrlF24Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavCcRecuVictSuivi = control.get('bavCcRecuVictSuivi').value;
    const bavCcRecuVictNb = control.get('bavCcRecuVictNb').value;

    if (bavCcRecuVictSuivi !== null && bavCcRecuVictNb !== null && Number(bavCcRecuVictSuivi) > Number(bavCcRecuVictNb)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlF24Bav': { value: control.value } } : null;
  }
  /* controle sur bavCcRecuNvictSuivi */
  public ctrlF25Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavCcRecuNvictSuivi = control.get('bavCcRecuNvictSuivi').value;
    const bavCcRecuNvictNb = control.get('bavCcRecuNvictNb').value;

    if (bavCcRecuNvictSuivi !== null && bavCcRecuNvictNb !== null && Number(bavCcRecuNvictSuivi) > Number(bavCcRecuNvictNb)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlF25Bav': { value: control.value } } : null;
  }
  /* controle sur bavCcRecuSuiviTot */
  public ctrlF6Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavCcRecuSuiviTot = control.get('bavCcRecuSuiviTot').value;
    const bavCcRecuVictSuivi = Number(control.get('bavCcRecuVictSuivi').value);
    const bavCcRecuNvictSuivi = Number(control.get('bavCcRecuNvictSuivi').value);

    if (bavCcRecuSuiviTot === null && bavCcRecuVictSuivi === 0 && bavCcRecuNvictSuivi === 0) {
      resultat = false;
    } else {
      if (bavCcRecuSuiviTot !== null && Number(bavCcRecuSuiviTot) < (bavCcRecuVictSuivi + bavCcRecuNvictSuivi)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlF6Bav': { value: control.value } } : null;
  }
  /* controle sur bavCcRecuVictEntret */
  public ctrlF26Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavCcRecuVictEntret = control.get('bavCcRecuVictEntret').value;
    const bavCcRecuVictNb = control.get('bavCcRecuVictNb').value;

    if (bavCcRecuVictEntret !== null && bavCcRecuVictNb !== null && Number(bavCcRecuVictEntret) < Number(bavCcRecuVictNb)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlF26Bav': { value: control.value } } : null;
  }
  /* controle sur bavCcRecuNvictEntret */
  public ctrlF27Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavCcRecuNvictEntret = control.get('bavCcRecuNvictEntret').value;
    const bavCcRecuNvictNb = control.get('bavCcRecuNvictNb').value;

    if (bavCcRecuNvictEntret !== null && bavCcRecuNvictNb !== null && Number(bavCcRecuNvictEntret) < Number(bavCcRecuNvictNb)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlF27Bav': { value: control.value } } : null;
  }
  /* controle sur bavCcRecuEntretTot */
  public ctrlF7Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavCcRecuEntretTot = control.get('bavCcRecuEntretTot').value;
    const bavCcRecuVictEntret = Number(control.get('bavCcRecuVictEntret').value);
    const bavCcRecuNvictEntret = Number(control.get('bavCcRecuNvictEntret').value);

    if (bavCcRecuEntretTot === null && bavCcRecuVictEntret === 0 && bavCcRecuNvictEntret === 0) {
      resultat = false;
    } else {
      if (bavCcRecuEntretTot !== null && Number(bavCcRecuEntretTot) < (bavCcRecuVictEntret + bavCcRecuNvictEntret)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlF7Bav': { value: control.value } } : null;
  }
  /* controle sur bavCcRecuVict */
  public ctrlF28Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavCcRecuVict = control.get('bavCcRecuVict').value;
    const bavCcRecuVictNb = control.get('bavCcRecuVictNb').value;

    if (bavCcRecuVict !== null && bavCcRecuVictNb !== null && Number(bavCcRecuVict) !== Number(bavCcRecuVictNb)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlF28Bav': { value: control.value } } : null;
  }
  /* controle sur bavCcRecuVictPc */
  public ctrlF29Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavCcRecuVictPc = control.get('bavCcRecuVictPc').value;
    const bavCcRecuVict = control.get('bavCcRecuVict').value;

    if (bavCcRecuVictPc !== null && bavCcRecuVict !== null && Number(bavCcRecuVictPc) > Number(bavCcRecuVict)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlF29Bav': { value: control.value } } : null;
  }
  /* controle sur bavCcRecuVictAud */
  public ctrlF30Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavCcRecuVictAud = control.get('bavCcRecuVictAud').value;
    const bavCcRecuVict = control.get('bavCcRecuVict').value;

    if (bavCcRecuVictAud !== null && bavCcRecuVict !== null && Number(bavCcRecuVictAud) > Number(bavCcRecuVict)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlF30Bav': { value: control.value } } : null;
  }
  /* controle sur bavDdFaitPersoTot */
  public ctrlF8Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavDdFaitPersoTot = control.get('bavDdFaitPersoTot').value;
    const bavDdFaitPersoHomiVolo = Number(control.get('bavDdFaitPersoHomiVolo').value);
    const bavDdFaitPersoSexuel = Number(control.get('bavDdFaitPersoSexuel').value);
    const bavDdFaitPersoProxe = Number(control.get('bavDdFaitPersoProxe').value);
    const bavDdFaitPersoViolen = Number(control.get('bavDdFaitPersoViolen').value);
    const bavDdFaitPersoHomiInvolo = Number(control.get('bavDdFaitPersoHomiInvolo').value);
    const bavDdFaitPersoBless = Number(control.get('bavDdFaitPersoBless').value);
    const bavDdFaitPersoAband = Number(control.get('bavDdFaitPersoAband').value);
    const bavDdFaitPersoMenace = Number(control.get('bavDdFaitPersoMenace').value);
    const bavDdFaitPersoDiscri = Number(control.get('bavDdFaitPersoDiscri').value);
    const bavDdFaitPersoAutr = Number(control.get('bavDdFaitPersoAutr').value);

    if (bavDdFaitPersoTot === null && bavDdFaitPersoHomiVolo === 0 && bavDdFaitPersoSexuel === 0 && bavDdFaitPersoProxe === 0 && bavDdFaitPersoViolen === 0
      && bavDdFaitPersoHomiInvolo === 0 && bavDdFaitPersoBless === 0 && bavDdFaitPersoAband === 0 && bavDdFaitPersoMenace === 0
      && bavDdFaitPersoDiscri === 0 && bavDdFaitPersoAutr === 0) {
      resultat = false;
    } else {
      if (bavDdFaitPersoTot !== null && Number(bavDdFaitPersoTot) < (bavDdFaitPersoHomiVolo + bavDdFaitPersoSexuel + bavDdFaitPersoProxe + bavDdFaitPersoViolen
        + bavDdFaitPersoHomiInvolo + bavDdFaitPersoBless + bavDdFaitPersoAband + bavDdFaitPersoMenace + bavDdFaitPersoDiscri + bavDdFaitPersoAutr)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlF8Bav': { value: control.value } } : null;
  }
  /* controle sur bavDdFaitBienTot */
  public ctrlF9Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavDdFaitBienTot = control.get('bavDdFaitBienTot').value;
    const bavDdFaitBienVolSimp = Number(control.get('bavDdFaitBienVolSimp').value);
    const bavDdFaitBienVolAggr = Number(control.get('bavDdFaitBienVolAggr').value);
    const bavDdFaitBienEscro = Number(control.get('bavDdFaitBienEscro').value);
    const bavDdFaitBienDegrad = Number(control.get('bavDdFaitBienDegrad').value);
    const bavDdFaitBienAutr = Number(control.get('bavDdFaitBienAutr').value);

    if (bavDdFaitBienTot === null && bavDdFaitBienVolSimp === 0 && bavDdFaitBienVolAggr === 0 && bavDdFaitBienEscro === 0 && bavDdFaitBienDegrad === 0
      && bavDdFaitBienAutr === 0) {
      resultat = false;
    } else {
      if (bavDdFaitBienTot !== null && Number(bavDdFaitBienTot) < (bavDdFaitBienVolSimp + bavDdFaitBienVolAggr + bavDdFaitBienEscro + bavDdFaitBienDegrad
        + bavDdFaitBienAutr)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlF9Bav': { value: control.value } } : null;
  }
  /* controle sur bavDdFaitCircuTot */
  public ctrlF10Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavDdFaitCircuTot = control.get('bavDdFaitCircuTot').value;
    const bavDdFaitCircuBless = Number(control.get('bavDdFaitCircuBless').value);
    const bavDdFaitCircuDegat = Number(control.get('bavDdFaitCircuDegat').value);

    if (bavDdFaitCircuTot === null && bavDdFaitCircuBless === 0 && bavDdFaitCircuDegat === 0) {
      resultat = false;
    } else {
      if (bavDdFaitCircuTot !== null && Number(bavDdFaitCircuTot) < (bavDdFaitCircuBless + bavDdFaitCircuDegat)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlF10Bav': { value: control.value } } : null;
  }
  /* controle sur bavDdFaitTot */
  public ctrlF11Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavDdFaitTot = control.get('bavDdFaitTot').value;
    const bavDdFaitPersoTot = Number(control.get('bavDdFaitPersoTot').value);
    const bavDdFaitBienTot = Number(control.get('bavDdFaitBienTot').value);
    const bavDdFaitCircuTot = Number(control.get('bavDdFaitCircuTot').value);
    const bavDdFaitAutr = Number(control.get('bavDdFaitAutr').value);

    if (bavDdFaitTot === null && bavDdFaitPersoTot === 0 && bavDdFaitBienTot === 0 && bavDdFaitCircuTot === 0 && bavDdFaitAutr === 0) {
      resultat = false;
    } else {
      if (bavDdFaitTot !== null && Number(bavDdFaitTot) < (bavDdFaitPersoTot + bavDdFaitBienTot + bavDdFaitCircuTot + bavDdFaitAutr)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlF11Bav': { value: control.value } } : null;
  }
  /* controle sur bavDdFaitTot */
  public ctrlF31Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavDdFaitTot = control.get('bavDdFaitTot').value;
    const bavCcRecuVictNb = control.get('bavCcRecuVictNb').value;

    if (bavDdFaitTot !== null && bavCcRecuVictNb !== null && Number(bavDdFaitTot) !== Number(bavCcRecuVictNb)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlF31Bav': { value: control.value } } : null;
  }
  /* controle sur bavEeEntretTot */
  public ctrlF12Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavEeEntretTot = control.get('bavEeEntretTot').value;
    const bavEeEntretPsy = Number(control.get('bavEeEntretPsy').value);
    const bavEeEntretJur = Number(control.get('bavEeEntretJur').value);
    const bavEeEntretSoc = Number(control.get('bavEeEntretSoc').value);
    const bavEeEntretEcout = Number(control.get('bavEeEntretEcout').value);
    const bavEeEntretAutr = Number(control.get('bavEeEntretAutr').value);

    if (bavEeEntretTot === null && bavEeEntretPsy === 0 && bavEeEntretJur === 0 && bavEeEntretSoc === 0 && bavEeEntretEcout === 0
      && bavEeEntretAutr === 0
    ) {
      resultat = false;
    } else {
      if (bavEeEntretTot !== null && Number(bavEeEntretTot) < (bavEeEntretPsy + bavEeEntretJur + bavEeEntretSoc + bavEeEntretEcout
        + bavEeEntretAutr)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlF12Bav': { value: control.value } } : null;
  }
  /* controle sur bavEeDiliTot */
  public ctrlF13Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavEeDiliTot = control.get('bavEeDiliTot').value;
    const bavEeDiliJur = Number(control.get('bavEeDiliJur').value);
    const bavEeDiliCivi = Number(control.get('bavEeDiliCivi').value);
    const bavEeDiliFondGaran = Number(control.get('bavEeDiliFondGaran').value);
    const bavEeDiliSarvi = Number(control.get('bavEeDiliSarvi').value);
    const bavEeDiliPenit = Number(control.get('bavEeDiliPenit').value);
    const bavEeDiliPolgend = Number(control.get('bavEeDiliPolgend').value);
    const bavEeDiliAvoc = Number(control.get('bavEeDiliAvoc').value);
    const bavEeDiliHuis = Number(control.get('bavEeDiliHuis').value);
    const bavEeDiliOrgaSoc = Number(control.get('bavEeDiliOrgaSoc').value);
    const bavEeDiliColter = Number(control.get('bavEeDiliColter').value);
    const bavEeDiliPref = Number(control.get('bavEeDiliPref').value);
    const bavEeDiliOrgaLogt = Number(control.get('bavEeDiliOrgaLogt').value);
    const bavEeDiliHebgt = Number(control.get('bavEeDiliHebgt').value);
    const bavEeDiliHosto = Number(control.get('bavEeDiliHosto').value);
    const bavEeDiliAsso = Number(control.get('bavEeDiliAsso').value);
    const bavEeDiliAssur = Number(control.get('bavEeDiliAssur').value);
    const bavEeDiliSad = Number(control.get('bavEeDiliSad').value);
    const bavEeDiliFrserv = Number(control.get('bavEeDiliFrserv').value);
    const bavEeDiliAutr = Number(control.get('bavEeDiliAutr').value);

    if (bavEeDiliTot === null && bavEeDiliJur === 0 && bavEeDiliCivi === 0 && bavEeDiliFondGaran === 0
      && bavEeDiliSarvi === 0 && bavEeDiliPenit === 0 && bavEeDiliPolgend === 0 && bavEeDiliAvoc === 0
      && bavEeDiliHuis === 0 && bavEeDiliOrgaSoc === 0 && bavEeDiliColter === 0 && bavEeDiliPref === 0
      && bavEeDiliOrgaLogt === 0 && bavEeDiliHebgt === 0 && bavEeDiliHosto === 0 && bavEeDiliAsso === 0
      && bavEeDiliAssur === 0 && bavEeDiliSad === 0 && bavEeDiliFrserv === 0
      && bavEeDiliAutr === 0) {
      resultat = false;
    } else {
      if (bavEeDiliTot !== null && Number(bavEeDiliTot) < (bavEeDiliJur + bavEeDiliCivi + bavEeDiliFondGaran + bavEeDiliSarvi
        + bavEeDiliPenit + bavEeDiliPolgend + bavEeDiliAvoc + bavEeDiliHuis + bavEeDiliOrgaSoc + bavEeDiliColter + bavEeDiliPref
        + bavEeDiliOrgaLogt + bavEeDiliHebgt + bavEeDiliHosto + bavEeDiliAsso + bavEeDiliAssur + bavEeDiliSad + bavEeDiliFrserv
        + bavEeDiliAutr)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlF13Bav': { value: control.value } } : null;
  }
  /* Controle sur bavEeAideCivi */
  public ctrlF32Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavEeAideCivi = control.get('bavEeAideCivi').value;
    const bavCcRecuVictNb = control.get('bavCcRecuVictNb').value;

    if (bavEeAideCivi !== null && bavCcRecuVictNb !== null && Number(bavEeAideCivi) > Number(bavCcRecuVictNb)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlF32Bav': { value: control.value } } : null;
  }
  /* Controle sur bavEeAideSarvi */
  public ctrlF33Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavEeAideSarvi = control.get('bavEeAideSarvi').value;
    const bavCcRecuVictNb = control.get('bavCcRecuVictNb').value;

    if (bavEeAideSarvi !== null && bavCcRecuVictNb !== null && Number(bavEeAideSarvi) > Number(bavCcRecuVictNb)) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlF33Bav': { value: control.value } } : null;
  }
  /* controle sur bavEeProcPreSentenTot */
  public ctrlF14Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavEeProcPreSentenTot = control.get('bavEeProcPreSentenTot').value;
    const bavEeProcPreSentenPlainte = Number(control.get('bavEeProcPreSentenPlainte').value);
    const bavEeProcPreSentenEnq = Number(control.get('bavEeProcPreSentenEnq').value);
    const bavEeProcPreSentenCss = Number(control.get('bavEeProcPreSentenCss').value);
    const bavEeProcPreSentenPc = Number(control.get('bavEeProcPreSentenPc').value);
    const bavEeProcPreSentenAud = Number(control.get('bavEeProcPreSentenAud').value);
    const bavEeProcPreSentenAutr = Number(control.get('bavEeProcPreSentenAutr').value);

    if (bavEeProcPreSentenTot === null && bavEeProcPreSentenPlainte === 0 && bavEeProcPreSentenEnq === 0 && bavEeProcPreSentenCss === 0 && bavEeProcPreSentenPc === 0
      && bavEeProcPreSentenAud === 0 && bavEeProcPreSentenAutr === 0
    ) {
      resultat = false;
    } else {
      if (bavEeProcPreSentenTot !== null && Number(bavEeProcPreSentenTot) < (bavEeProcPreSentenPlainte + bavEeProcPreSentenEnq + bavEeProcPreSentenCss + bavEeProcPreSentenPc
        + bavEeProcPreSentenAud + bavEeProcPreSentenAutr)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlF14Bav': { value: control.value } } : null;
  }
  /* controle sur bavEeProcPostSentenTot */
  public ctrlF15Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavEeProcPostSentenTot = control.get('bavEeProcPostSentenTot').value;
    const bavEeProcPostSentenDec = Number(control.get('bavEeProcPostSentenDec').value);
    const bavEeProcPostSentenDef = Number(control.get('bavEeProcPostSentenDef').value);
    const bavEeProcPostSentenRecour = Number(control.get('bavEeProcPostSentenRecour').value);
    const bavEeProcPostSentenAutr = Number(control.get('bavEeProcPostSentenAutr').value);

    if (bavEeProcPostSentenTot === null && bavEeProcPostSentenDec === 0 && bavEeProcPostSentenDef === 0 && bavEeProcPostSentenRecour === 0
      && bavEeProcPostSentenAutr === 0
    ) {
      resultat = false;
    } else {
      if (bavEeProcPostSentenTot !== null && Number(bavEeProcPostSentenTot) < (bavEeProcPostSentenDec + bavEeProcPostSentenDef + bavEeProcPostSentenRecour
        + bavEeProcPostSentenAutr)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlF15Bav': { value: control.value } } : null;
  }
  /* controle sur bavEeAuteurPreSentenTot */
  public ctrlF16Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavEeAuteurPreSentenTot = control.get('bavEeAuteurPreSentenTot').value;
    const bavEeAuteurPreSentenCj = Number(control.get('bavEeAuteurPreSentenCj').value);
    const bavEeAuteurPreSentenDp = Number(control.get('bavEeAuteurPreSentenDp').value);
    const bavEeAuteurPreSentenFinDeten = Number(control.get('bavEeAuteurPreSentenFinDeten').value);
    const bavEeAuteurPreSentenFinMes = Number(control.get('bavEeAuteurPreSentenFinMes').value);
    const bavEeAuteurPreSentenAutr = Number(control.get('bavEeAuteurPreSentenAutr').value);

    if (bavEeAuteurPreSentenTot === null && bavEeAuteurPreSentenCj === 0 && bavEeAuteurPreSentenDp === 0 && bavEeAuteurPreSentenFinDeten === 0 && bavEeAuteurPreSentenFinMes === 0
      && bavEeAuteurPreSentenAutr === 0
    ) {
      resultat = false;
    } else {
      if (bavEeAuteurPreSentenTot !== null && Number(bavEeAuteurPreSentenTot) < (bavEeAuteurPreSentenCj + bavEeAuteurPreSentenDp + bavEeAuteurPreSentenFinDeten + bavEeAuteurPreSentenFinMes
        + bavEeAuteurPreSentenAutr)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlF16Bav': { value: control.value } } : null;
  }
  /* controle sur bavEeAuteurPostSentenTot */
  public ctrlF17Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavEeAuteurPostSentenTot = control.get('bavEeAuteurPostSentenTot').value;
    const bavEeAuteurPostSentenMilFer = Number(control.get('bavEeAuteurPostSentenMilFer').value);
    const bavEeAuteurPostSentenMilOuv = Number(control.get('bavEeAuteurPostSentenMilOuv').value);
    const bavEeAuteurPostSentenFinDeten = Number(control.get('bavEeAuteurPostSentenFinDeten').value);
    const bavEeAuteurPostSentenFinMes = Number(control.get('bavEeAuteurPostSentenFinMes').value);
    const bavEeAuteurPostSentenAutr = Number(control.get('bavEeAuteurPostSentenAutr').value);

    if (bavEeAuteurPostSentenTot === null && bavEeAuteurPostSentenMilFer === 0 && bavEeAuteurPostSentenMilOuv === 0 && bavEeAuteurPostSentenFinDeten === 0 && bavEeAuteurPostSentenFinMes === 0
      && bavEeAuteurPostSentenAutr === 0
    ) {
      resultat = false;
    } else {
      if (bavEeAuteurPostSentenTot !== null && Number(bavEeAuteurPostSentenTot) < (bavEeAuteurPostSentenMilFer + bavEeAuteurPostSentenMilOuv + bavEeAuteurPostSentenFinDeten + bavEeAuteurPostSentenFinMes
        + bavEeAuteurPostSentenAutr)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlF17Bav': { value: control.value } } : null;
  }
  /* controle sur bavEeDiPreSentenTot */
  public ctrlF18Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavEeDiPreSentenTot = control.get('bavEeDiPreSentenTot').value;
    const bavEeDiPreSentenCivi = Number(control.get('bavEeDiPreSentenCivi').value);
    const bavEeDiPreSentenAutr = Number(control.get('bavEeDiPreSentenAutr').value);

    if (bavEeDiPreSentenTot === null && bavEeDiPreSentenCivi === 0 && bavEeDiPreSentenAutr === 0) {
      resultat = false;
    } else {
      if (bavEeDiPreSentenTot !== null && Number(bavEeDiPreSentenTot) < (bavEeDiPreSentenCivi + bavEeDiPreSentenAutr)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlF18Bav': { value: control.value } } : null;
  }
  /* controle sur bavEeDiPostSentenTot */
  public ctrlF19Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavEeDiPostSentenTot = control.get('bavEeDiPostSentenTot').value;
    const bavEeDiPostSentenCivi = Number(control.get('bavEeDiPostSentenCivi').value);
    const bavEeDiPostSentenSarvi = Number(control.get('bavEeDiPostSentenSarvi').value);
    const bavEeDiPostSentenHuis = Number(control.get('bavEeDiPostSentenHuis').value);
    const bavEeDiPostSentenJapSpip = Number(control.get('bavEeDiPostSentenJapSpip').value);
    const bavEeDiPostSentenFondGar = Number(control.get('bavEeDiPostSentenFondGar').value);
    const bavEeDiPostSentenAutr = Number(control.get('bavEeDiPostSentenAutr').value);

    if (bavEeDiPostSentenTot === null && bavEeDiPostSentenCivi === 0 && bavEeDiPostSentenSarvi === 0 && bavEeDiPostSentenHuis === 0 && bavEeDiPostSentenJapSpip === 0 && bavEeDiPostSentenFondGar === 0
      && bavEeDiPostSentenAutr === 0
    ) {
      resultat = false;
    } else {
      if (bavEeDiPostSentenTot !== null && Number(bavEeDiPostSentenTot) < (bavEeDiPostSentenCivi + bavEeDiPostSentenSarvi + bavEeDiPostSentenHuis + bavEeDiPostSentenJapSpip + bavEeDiPostSentenFondGar
        + bavEeDiPostSentenAutr)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlF19Bav': { value: control.value } } : null;
  }
  /* controle sur bavEeDemarTot */
  public ctrlF20Bav: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavEeDemarTot = control.get('bavEeDemarTot').value;
    const bavEeDemarPlainte = Number(control.get('bavEeDemarPlainte').value);
    const bavEeDemarAj = Number(control.get('bavEeDemarAj').value);
    const bavEeDemarAud = Number(control.get('bavEeDemarAud').value);
    const bavEeDemarAccomp = Number(control.get('bavEeDemarAccomp').value);
    const bavEeDemarDi = Number(control.get('bavEeDemarDi').value);
    const bavEeDemarAutr = Number(control.get('bavEeDemarAutr').value);

    if (bavEeDemarTot === null && bavEeDemarPlainte === 0 && bavEeDemarAj === 0 && bavEeDemarAud === 0 && bavEeDemarAccomp === 0 && bavEeDemarDi === 0
      && bavEeDemarAutr === 0
    ) {
      resultat = false;
    } else {
      if (bavEeDemarTot !== null && Number(bavEeDemarTot) < (bavEeDemarPlainte + bavEeDemarAj + bavEeDemarAud + bavEeDemarAccomp + bavEeDemarDi
        + bavEeDemarAutr)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlF20Bav': { value: control.value } } : null;
  }

  /*** Controles sur Synthèse BAV ****/
  /***********************************/
  /* Controle sur bavtotAaNbAav */
  private ctrlG1: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotAaNbAav = control.get('bavtotAaNbAav').value;
    const aaNbCdiAav = Number(control.root.get('moyens').get('aaNbCdiAav').value);
    const aaNbCddAav = Number(control.root.get('moyens').get('aaNbCddAav').value);
    const aaNbPrestaAav = Number(control.root.get('moyens').get('aaNbPrestaAav').value);
    const aaNbBnvlAav = Number(control.root.get('moyens').get('aaNbBnvlAav').value);

    if (bavtotAaNbAav === null && aaNbCdiAav === 0 && aaNbCddAav === 0 && aaNbPrestaAav === 0 && aaNbBnvlAav === 0) {
      resultat = false;
    } else {
      if (bavtotAaNbAav !== null && Number(bavtotAaNbAav) > (aaNbCdiAav + aaNbCddAav + aaNbPrestaAav + aaNbBnvlAav)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlG1': { value: control.value } } : null;
  }
  /* Controle sur bavtotAaNbJur */
  private ctrlG2: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotAaNbJur = control.get('bavtotAaNbJur').value;
    const aaNbCdiJur = Number(control.root.get('moyens').get('aaNbCdiJur').value);
    const aaNbCddJur = Number(control.root.get('moyens').get('aaNbCddJur').value);
    const aaNbPrestaJur = Number(control.root.get('moyens').get('aaNbPrestaJur').value);
    const aaNbBnvlJur = Number(control.root.get('moyens').get('aaNbBnvlJur').value);

    if (bavtotAaNbJur === null && aaNbCdiJur === 0 && aaNbCddJur === 0 && aaNbPrestaJur === 0 && aaNbBnvlJur === 0) {
      resultat = false;
    } else {
      if (bavtotAaNbJur !== null && Number(bavtotAaNbJur) > (aaNbCdiJur + aaNbCddJur + aaNbPrestaJur + aaNbBnvlJur)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlG2': { value: control.value } } : null;
  }
  /* Controle sur bavtotAaNbPsy */
  private ctrlG3: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotAaNbPsy = control.get('bavtotAaNbPsy').value;
    const aaNbCdiPsy = Number(control.root.get('moyens').get('aaNbCdiPsy').value);
    const aaNbCddPsy = Number(control.root.get('moyens').get('aaNbCddPsy').value);
    const aaNbPrestaPsy = Number(control.root.get('moyens').get('aaNbPrestaPsy').value);
    const aaNbBnvlPsy = Number(control.root.get('moyens').get('aaNbBnvlPsy').value);

    if (bavtotAaNbPsy === null && aaNbCdiPsy === 0 && aaNbCddPsy === 0 && aaNbPrestaPsy === 0 && aaNbBnvlPsy === 0) {
      resultat = false;
    } else {
      if (bavtotAaNbPsy !== null && Number(bavtotAaNbPsy) > (aaNbCdiPsy + aaNbCddPsy + aaNbPrestaPsy + aaNbBnvlPsy)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlG3': { value: control.value } } : null;
  }
  /* Controle sur bavtotAaNbWsoc */
  private ctrlG4: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotAaNbWsoc = control.get('bavtotAaNbWsoc').value;
    const aaNbCdiWsoc = Number(control.root.get('moyens').get('aaNbCdiWsoc').value);
    const aaNbCddWsoc = Number(control.root.get('moyens').get('aaNbCddWsoc').value);
    const aaNbPrestaWsoc = Number(control.root.get('moyens').get('aaNbPrestaWsoc').value);
    const aaNbBnvlWsoc = Number(control.root.get('moyens').get('aaNbBnvlWsoc').value);

    if (bavtotAaNbWsoc === null && aaNbCdiWsoc === 0 && aaNbCddWsoc === 0 && aaNbPrestaWsoc === 0 && aaNbBnvlWsoc === 0) {
      resultat = false;
    } else {
      if (bavtotAaNbWsoc !== null && Number(bavtotAaNbWsoc) > (aaNbCdiWsoc + aaNbCddWsoc + aaNbPrestaWsoc + aaNbBnvlWsoc)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlG4': { value: control.value } } : null;
  }
  /* Controle sur bavtotAaNbAutrInterv */
  private ctrlG5: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotAaNbAutrInterv = control.get('bavtotAaNbAutrInterv').value;
    const aaNbCdiAutrInterv = Number(control.root.get('moyens').get('aaNbCdiAutrInterv').value);
    const aaNbCddAutrInterv = Number(control.root.get('moyens').get('aaNbCddAutrInterv').value);
    const aaNbPrestaAutrInterv = Number(control.root.get('moyens').get('aaNbPrestaAutrInterv').value);
    const aaNbBnvlAutrInterv = Number(control.root.get('moyens').get('aaNbBnvlAutrInterv').value);

    if (bavtotAaNbAutrInterv === null && aaNbCdiAutrInterv === 0 && aaNbCddAutrInterv === 0 && aaNbPrestaAutrInterv === 0 && aaNbBnvlAutrInterv === 0) {
      resultat = false;
    } else {
      if (bavtotAaNbAutrInterv !== null && Number(bavtotAaNbAutrInterv) > (aaNbCdiAutrInterv + aaNbCddAutrInterv + aaNbPrestaAutrInterv + aaNbBnvlAutrInterv)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlG5': { value: control.value } } : null;
  }
  /* Controle sur bavtotAaNbDir */
  private ctrlG6: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotAaNbDir = control.get('bavtotAaNbDir').value;
    const aaNbCdiDir = Number(control.root.get('moyens').get('aaNbCdiDir').value);
    const aaNbCddDir = Number(control.root.get('moyens').get('aaNbCddDir').value);
    const aaNbPrestaDir = Number(control.root.get('moyens').get('aaNbPrestaDir').value);
    const aaNbBnvlDir = Number(control.root.get('moyens').get('aaNbBnvlDir').value);

    if (bavtotAaNbDir === null && aaNbCdiDir === 0 && aaNbCddDir === 0 && aaNbPrestaDir === 0 && aaNbBnvlDir === 0) {
      resultat = false;
    } else {
      if (bavtotAaNbDir !== null && Number(bavtotAaNbDir) > (aaNbCdiDir + aaNbCddDir + aaNbPrestaDir + aaNbBnvlDir)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlG6': { value: control.value } } : null;
  }
  /* Controle sur bavtotAaNbComptsecr */
  private ctrlG7: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotAaNbComptsecr = control.get('bavtotAaNbComptsecr').value;
    const aaNbCdiComptsecr = Number(control.root.get('moyens').get('aaNbCdiComptsecr').value);
    const aaNbCddComptsecr = Number(control.root.get('moyens').get('aaNbCddComptsecr').value);
    const aaNbPrestaComptsecr = Number(control.root.get('moyens').get('aaNbPrestaComptsecr').value);
    const aaNbBnvlComptsecr = Number(control.root.get('moyens').get('aaNbBnvlComptsecr').value);

    if (bavtotAaNbComptsecr === null && aaNbCdiComptsecr === 0 && aaNbCddComptsecr === 0 && aaNbPrestaComptsecr === 0 && aaNbBnvlComptsecr === 0) {
      resultat = false;
    } else {
      if (bavtotAaNbComptsecr !== null && Number(bavtotAaNbComptsecr) > (aaNbCdiComptsecr + aaNbCddComptsecr + aaNbPrestaComptsecr + aaNbBnvlComptsecr)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlG7': { value: control.value } } : null;
  }
  /* Controle sur bavtotAaNbAutrSupport */
  private ctrlG8: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotAaNbAutrSupport = control.get('bavtotAaNbAutrSupport').value;
    const aaNbCdiAutrSupport = Number(control.root.get('moyens').get('aaNbCdiAutrSupport').value);
    const aaNbCddAutrSupport = Number(control.root.get('moyens').get('aaNbCddAutrSupport').value);
    const aaNbPrestaAutrSupport = Number(control.root.get('moyens').get('aaNbPrestaAutrSupport').value);
    const aaNbBnvlAutrSupport = Number(control.root.get('moyens').get('aaNbBnvlAutrSupport').value);

    if (bavtotAaNbAutrSupport === null && aaNbCdiAutrSupport === 0 && aaNbCddAutrSupport === 0 && aaNbPrestaAutrSupport === 0 && aaNbBnvlAutrSupport === 0) {
      resultat = false;
    } else {
      if (bavtotAaNbAutrSupport !== null && Number(bavtotAaNbAutrSupport) > (aaNbCdiAutrSupport + aaNbCddAutrSupport + aaNbPrestaAutrSupport + aaNbBnvlAutrSupport)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlG8': { value: control.value } } : null;
  }
  /* Controle sur bavtotAaNbTot */
  private ctrlG9: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotAaNbTot = control.get('bavtotAaNbTot').value;
    const aaNbCdiTot = Number(control.root.get('moyens').get('aaNbCdiTot').value);
    const aaNbCddTot = Number(control.root.get('moyens').get('aaNbCddTot').value);
    const aaNbPrestaTot = Number(control.root.get('moyens').get('aaNbPrestaTot').value);
    const aaNbBnvlTot = Number(control.root.get('moyens').get('aaNbBnvlTot').value);

    // console.log(bavtotAaNbTot);
    // console.log(aaNbCdiTot + aaNbCddTot + aaNbPrestaTot + aaNbBnvlTot);

    if (bavtotAaNbTot === null && aaNbCdiTot === 0 && aaNbCddTot === 0 && aaNbPrestaTot === 0 && aaNbBnvlTot === 0) {
      resultat = false;
    } else {
      if (bavtotAaNbTot !== null && Number(bavtotAaNbTot) > (aaNbCdiTot + aaNbCddTot + aaNbPrestaTot + aaNbBnvlTot)) {
        resultat = true;
      } else {
        resultat = false;
      }
    }
    return resultat ? { 'ctrlG9': { value: control.value } } : null;
  }
  /* controle sur bavtotAaEtpAav*/
  private ctrlG10: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotAaEtpAav = control.get("bavtotAaEtpAav").value;
    const bavtotAaEtpAav_float = parseFloat(control.get("bavtotAaEtpAav").value) || 0;
    const aaEtpCddAav = parseFloat(control.root.get('moyens').get("aaEtpCddAav").value) || 0;
    const aaEtpPrestaAav = parseFloat(control.root.get('moyens').get("aaEtpPrestaAav").value) || 0;
    const aaEtpCdiAav = parseFloat(control.root.get('moyens').get("aaEtpCdiAav").value) || 0;
    const aaEtpBnvlAav = parseFloat(control.root.get('moyens').get("aaEtpBnvlAav").value) || 0;
    // Pour ces variables décimales ETPT, le FloatInputComponent manipule les nombres décimaux
    // en virgule flottante avec 3 décimales après le séparateur décimal, alors qu'on souhaite seulement
    // 2 décimales dans l'interface et côté API, conformément à la spécification.
    // On cherche à comparer ces nombres décimaux en virgule flottante limités à 2 décimales
    // et non pas des string qui sont comparées selon les valeurs des codes Unicode des
    // caractères qu'elles contiennent : les number 11.11 > 2.22, mais les string '11.11' < '2.22'
    // Or la méthode toFixed(2) sur un number renvoie une string et non pas un number. A partir de la string
    // formatée par toFixed(2), il faut donc utiliser parseFloat() pour manipuler de nouveau un number.

    const sommeTableau = (aaEtpCddAav + aaEtpPrestaAav + aaEtpCdiAav + aaEtpBnvlAav);

    if (bavtotAaEtpAav !== null && (parseFloat(bavtotAaEtpAav_float.toFixed(2)) > parseFloat(sommeTableau.toFixed(2)))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG10': { value: control.value } } : null;
  }
  /* controle sur bavtotAaEtpJur*/
  private ctrlG11: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotAaEtpJur = control.get("bavtotAaEtpJur").value;
    const bavtotAaEtpJur_float = parseFloat(control.get("bavtotAaEtpJur").value) || 0;
    const aaEtpCddJur = parseFloat(control.root.get('moyens').get("aaEtpCddJur").value) || 0;
    const aaEtpPrestaJur = parseFloat(control.root.get('moyens').get("aaEtpPrestaJur").value) || 0;
    const aaEtpCdiJur = parseFloat(control.root.get('moyens').get("aaEtpCdiJur").value) || 0;
    const aaEtpBnvlJur = parseFloat(control.root.get('moyens').get("aaEtpBnvlJur").value) || 0;
    // Pour ces variables décimales ETPT, le FloatInputComponent manipule les nombres décimaux
    // en virgule flottante avec 3 décimales après le séparateur décimal, alors qu'on souhaite seulement
    // 2 décimales dans l'interface et côté API, conformément à la spécification.
    // On cherche à comparer ces nombres décimaux en virgule flottante limités à 2 décimales
    // et non pas des string qui sont comparées selon les valeurs des codes Unicode des
    // caractères qu'elles contiennent : les number 11.11 > 2.22, mais les string '11.11' < '2.22'
    // Or la méthode toFixed(2) sur un number renvoie une string et non pas un number. A partir de la string
    // formatée par toFixed(2), il faut donc utiliser parseFloat() pour manipuler de nouveau un number.

    const sommeTableau = (aaEtpCddJur + aaEtpPrestaJur + aaEtpCdiJur + aaEtpBnvlJur);

    if (bavtotAaEtpJur !== null && (parseFloat(bavtotAaEtpJur_float.toFixed(2)) > parseFloat(sommeTableau.toFixed(2)))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG11': { value: control.value } } : null;
  }
  /* controle sur bavtotAaEtpPsy*/
  private ctrlG12: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotAaEtpPsy = control.get("bavtotAaEtpPsy").value;
    const bavtotAaEtpPsy_float = parseFloat(control.get("bavtotAaEtpPsy").value) || 0;
    const aaEtpCddPsy = parseFloat(control.root.get('moyens').get("aaEtpCddPsy").value) || 0;
    const aaEtpPrestaPsy = parseFloat(control.root.get('moyens').get("aaEtpPrestaPsy").value) || 0;
    const aaEtpCdiPsy = parseFloat(control.root.get('moyens').get("aaEtpCdiPsy").value) || 0;
    const aaEtpBnvlPsy = parseFloat(control.root.get('moyens').get("aaEtpBnvlPsy").value) || 0;
    // Pour ces variables décimales ETPT, le FloatInputComponent manipule les nombres décimaux
    // en virgule flottante avec 3 décimales après le séparateur décimal, alors qu'on souhaite seulement
    // 2 décimales dans l'interface et côté API, conformément à la spécification.
    // On cherche à comparer ces nombres décimaux en virgule flottante limités à 2 décimales
    // et non pas des string qui sont comparées selon les valeurs des codes Unicode des
    // caractères qu'elles contiennent : les number 11.11 > 2.22, mais les string '11.11' < '2.22'
    // Or la méthode toFixed(2) sur un number renvoie une string et non pas un number. A partir de la string
    // formatée par toFixed(2), il faut donc utiliser parseFloat() pour manipuler de nouveau un number.

    const sommeTableau = (aaEtpCddPsy + aaEtpPrestaPsy + aaEtpCdiPsy + aaEtpBnvlPsy);

    if (bavtotAaEtpPsy !== null && (parseFloat(bavtotAaEtpPsy_float.toFixed(2)) > parseFloat(sommeTableau.toFixed(2)))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG12': { value: control.value } } : null;
  }
  /* controle sur bavtotAaEtpWsoc*/
  private ctrlG13: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotAaEtpWsoc = control.get("bavtotAaEtpWsoc").value;
    const bavtotAaEtpWsoc_float = parseFloat(control.get("bavtotAaEtpWsoc").value) || 0;
    const aaEtpCddWsoc = parseFloat(control.root.get('moyens').get("aaEtpCddWsoc").value) || 0;
    const aaEtpPrestaWsoc = parseFloat(control.root.get('moyens').get("aaEtpPrestaWsoc").value) || 0;
    const aaEtpCdiWsoc = parseFloat(control.root.get('moyens').get("aaEtpCdiWsoc").value) || 0;
    const aaEtpBnvlWsoc = parseFloat(control.root.get('moyens').get("aaEtpBnvlWsoc").value) || 0;
    // Pour ces variables décimales ETPT, le FloatInputComponent manipule les nombres décimaux
    // en virgule flottante avec 3 décimales après le séparateur décimal, alors qu'on souhaite seulement
    // 2 décimales dans l'interface et côté API, conformément à la spécification.
    // On cherche à comparer ces nombres décimaux en virgule flottante limités à 2 décimales
    // et non pas des string qui sont comparées selon les valeurs des codes Unicode des
    // caractères qu'elles contiennent : les number 11.11 > 2.22, mais les string '11.11' < '2.22'
    // Or la méthode toFixed(2) sur un number renvoie une string et non pas un number. A partir de la string
    // formatée par toFixed(2), il faut donc utiliser parseFloat() pour manipuler de nouveau un number.

    const sommeTableau = (aaEtpCddWsoc + aaEtpPrestaWsoc + aaEtpCdiWsoc + aaEtpBnvlWsoc);

    if (bavtotAaEtpWsoc !== null && (parseFloat(bavtotAaEtpWsoc_float.toFixed(2)) > parseFloat(sommeTableau.toFixed(2)))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG13': { value: control.value } } : null;
  }
  /* controle sur bavtotAaEtpAutrInterv*/
  private ctrlG14: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotAaEtpAutrInterv = control.get("bavtotAaEtpAutrInterv").value;
    const bavtotAaEtpAutrInterv_float = parseFloat(control.get("bavtotAaEtpAutrInterv").value) || 0;
    const aaEtpCddAutrInterv = parseFloat(control.root.get('moyens').get("aaEtpCddAutrInterv").value) || 0;
    const aaEtpPrestaAutrInterv = parseFloat(control.root.get('moyens').get("aaEtpPrestaAutrInterv").value) || 0;
    const aaEtpCdiAutrInterv = parseFloat(control.root.get('moyens').get("aaEtpCdiAutrInterv").value) || 0;
    const aaEtpBnvlAutrInterv = parseFloat(control.root.get('moyens').get("aaEtpBnvlAutrInterv").value) || 0;
    // Pour ces variables décimales ETPT, le FloatInputComponent manipule les nombres décimaux
    // en virgule flottante avec 3 décimales après le séparateur décimal, alors qu'on souhaite seulement
    // 2 décimales dans l'interface et côté API, conformément à la spécification.
    // On cherche à comparer ces nombres décimaux en virgule flottante limités à 2 décimales
    // et non pas des string qui sont comparées selon les valeurs des codes Unicode des
    // caractères qu'elles contiennent : les number 11.11 > 2.22, mais les string '11.11' < '2.22'
    // Or la méthode toFixed(2) sur un number renvoie une string et non pas un number. A partir de la string
    // formatée par toFixed(2), il faut donc utiliser parseFloat() pour manipuler de nouveau un number.

    const sommeTableau = (aaEtpCddAutrInterv + aaEtpPrestaAutrInterv + aaEtpCdiAutrInterv + aaEtpBnvlAutrInterv);

    if (bavtotAaEtpAutrInterv !== null && (parseFloat(bavtotAaEtpAutrInterv_float.toFixed(2)) > parseFloat(sommeTableau.toFixed(2)))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG14': { value: control.value } } : null;
  }
  /* controle sur bavtotAaEtpDir*/
  private ctrlG15: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotAaEtpDir = control.get("bavtotAaEtpDir").value;
    const bavtotAaEtpDir_float = parseFloat(control.get("bavtotAaEtpDir").value) || 0;
    const aaEtpCddDir = parseFloat(control.root.get('moyens').get("aaEtpCddDir").value) || 0;
    const aaEtpPrestaDir = parseFloat(control.root.get('moyens').get("aaEtpPrestaDir").value) || 0;
    const aaEtpCdiDir = parseFloat(control.root.get('moyens').get("aaEtpCdiDir").value) || 0;
    const aaEtpBnvlDir = parseFloat(control.root.get('moyens').get("aaEtpBnvlDir").value) || 0;
    // Pour ces variables décimales ETPT, le FloatInputComponent manipule les nombres décimaux
    // en virgule flottante avec 3 décimales après le séparateur décimal, alors qu'on souhaite seulement
    // 2 décimales dans l'interface et côté API, conformément à la spécification.
    // On cherche à comparer ces nombres décimaux en virgule flottante limités à 2 décimales
    // et non pas des string qui sont comparées selon les valeurs des codes Unicode des
    // caractères qu'elles contiennent : les number 11.11 > 2.22, mais les string '11.11' < '2.22'
    // Or la méthode toFixed(2) sur un number renvoie une string et non pas un number. A partir de la string
    // formatée par toFixed(2), il faut donc utiliser parseFloat() pour manipuler de nouveau un number.

    const sommeTableau = (aaEtpCddDir + aaEtpPrestaDir + aaEtpCdiDir + aaEtpBnvlDir);

    if (bavtotAaEtpDir !== null && (parseFloat(bavtotAaEtpDir_float.toFixed(2)) > parseFloat(sommeTableau.toFixed(2)))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG15': { value: control.value } } : null;
  }
  /* controle sur bavtotAaEtpComptsecr*/
  private ctrlG16: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotAaEtpComptsecr = control.get("bavtotAaEtpComptsecr").value;
    const bavtotAaEtpComptsecr_float = parseFloat(control.get("bavtotAaEtpComptsecr").value) || 0;
    const aaEtpCddComptsecr = parseFloat(control.root.get('moyens').get("aaEtpCddComptsecr").value) || 0;
    const aaEtpPrestaComptsecr = parseFloat(control.root.get('moyens').get("aaEtpPrestaComptsecr").value) || 0;
    const aaEtpCdiComptsecr = parseFloat(control.root.get('moyens').get("aaEtpCdiComptsecr").value) || 0;
    const aaEtpBnvlComptsecr = parseFloat(control.root.get('moyens').get("aaEtpBnvlComptsecr").value) || 0;
    // Pour ces variables décimales ETPT, le FloatInputComponent manipule les nombres décimaux
    // en virgule flottante avec 3 décimales après le séparateur décimal, alors qu'on souhaite seulement
    // 2 décimales dans l'interface et côté API, conformément à la spécification.
    // On cherche à comparer ces nombres décimaux en virgule flottante limités à 2 décimales
    // et non pas des string qui sont comparées selon les valeurs des codes Unicode des
    // caractères qu'elles contiennent : les number 11.11 > 2.22, mais les string '11.11' < '2.22'
    // Or la méthode toFixed(2) sur un number renvoie une string et non pas un number. A partir de la string
    // formatée par toFixed(2), il faut donc utiliser parseFloat() pour manipuler de nouveau un number.

    const sommeTableau = (aaEtpCddComptsecr + aaEtpPrestaComptsecr + aaEtpCdiComptsecr + aaEtpBnvlComptsecr);

    if (bavtotAaEtpComptsecr !== null && (parseFloat(bavtotAaEtpComptsecr_float.toFixed(2)) > parseFloat(sommeTableau.toFixed(2)))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG16': { value: control.value } } : null;
  }
  /* controle sur bavtotAaEtpAutrSupport*/
  private ctrlG17: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotAaEtpAutrSupport = control.get("bavtotAaEtpAutrSupport").value;
    const bavtotAaEtpAutrSupport_float = parseFloat(control.get("bavtotAaEtpAutrSupport").value) || 0;
    const aaEtpCddAutrSupport = parseFloat(control.root.get('moyens').get("aaEtpCddAutrSupport").value) || 0;
    const aaEtpPrestaAutrSupport = parseFloat(control.root.get('moyens').get("aaEtpPrestaAutrSupport").value) || 0;
    const aaEtpCdiAutrSupport = parseFloat(control.root.get('moyens').get("aaEtpCdiAutrSupport").value) || 0;
    const aaEtpBnvlAutrSupport = parseFloat(control.root.get('moyens').get("aaEtpBnvlAutrSupport").value) || 0;
    // Pour ces variables décimales ETPT, le FloatInputComponent manipule les nombres décimaux
    // en virgule flottante avec 3 décimales après le séparateur décimal, alors qu'on souhaite seulement
    // 2 décimales dans l'interface et côté API, conformément à la spécification.
    // On cherche à comparer ces nombres décimaux en virgule flottante limités à 2 décimales
    // et non pas des string qui sont comparées selon les valeurs des codes Unicode des
    // caractères qu'elles contiennent : les number 11.11 > 2.22, mais les string '11.11' < '2.22'
    // Or la méthode toFixed(2) sur un number renvoie une string et non pas un number. A partir de la string
    // formatée par toFixed(2), il faut donc utiliser parseFloat() pour manipuler de nouveau un number.

    const sommeTableau = (aaEtpCddAutrSupport + aaEtpPrestaAutrSupport + aaEtpCdiAutrSupport + aaEtpBnvlAutrSupport);

    if (bavtotAaEtpAutrSupport !== null && (parseFloat(bavtotAaEtpAutrSupport_float.toFixed(2)) > parseFloat(sommeTableau.toFixed(2)))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG17': { value: control.value } } : null;
  }
  /* controle sur bavtotAaEtpTot*/
  private ctrlG18: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotAaEtpTot = control.get("bavtotAaEtpTot").value;
    const bavtotAaEtpTot_float = parseFloat(control.get("bavtotAaEtpTot").value) || 0;
    const aaEtpCddTot = parseFloat(control.root.get('moyens').get("aaEtpCddTot").value) || 0;
    const aaEtpPrestaTot = parseFloat(control.root.get('moyens').get("aaEtpPrestaTot").value) || 0;
    const aaEtpCdiTot = parseFloat(control.root.get('moyens').get("aaEtpCdiTot").value) || 0;
    const aaEtpBnvlTot = parseFloat(control.root.get('moyens').get("aaEtpBnvlTot").value) || 0;
    // Pour ces variables décimales ETPT, le FloatInputComponent manipule les nombres décimaux
    // en virgule flottante avec 3 décimales après le séparateur décimal, alors qu'on souhaite seulement
    // 2 décimales dans l'interface et côté API, conformément à la spécification.
    // On cherche à comparer ces nombres décimaux en virgule flottante limités à 2 décimales
    // et non pas des string qui sont comparées selon les valeurs des codes Unicode des
    // caractères qu'elles contiennent : les number 11.11 > 2.22, mais les string '11.11' < '2.22'
    // Or la méthode toFixed(2) sur un number renvoie une string et non pas un number. A partir de la string
    // formatée par toFixed(2), il faut donc utiliser parseFloat() pour manipuler de nouveau un number.

    const sommeTableau = (aaEtpCddTot + aaEtpPrestaTot + aaEtpCdiTot + aaEtpBnvlTot);

    if (bavtotAaEtpTot !== null && (parseFloat(bavtotAaEtpTot_float.toFixed(2)) > parseFloat(sommeTableau.toFixed(2)))
    ) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG18': { value: control.value } } : null;
  }
  /* Controle sur bavtotBbPremContactOrigAsso */
  private ctrlG19: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotBbPremContactOrigAsso = control.get('bavtotBbPremContactOrigAsso').value;
    const bbPremContactOrigAsso = Number(control.root.get('premiersContacts').get('bbPremContactOrigAsso').value);

    if (bavtotBbPremContactOrigAsso !== null && Number(bavtotBbPremContactOrigAsso) > bbPremContactOrigAsso) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG19': { value: control.value } } : null;
  }
  /* Controle sur bavtotBbPremContactOrigPerso */
  private ctrlG20: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotBbPremContactOrigPerso = control.get('bavtotBbPremContactOrigPerso').value;
    const bbPremContactOrigPerso = Number(control.root.get('premiersContacts').get('bbPremContactOrigPerso').value);

    if (bavtotBbPremContactOrigPerso !== null && Number(bavtotBbPremContactOrigPerso) > bbPremContactOrigPerso) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG20': { value: control.value } } : null;
  }
  /* Controle sur bavtotBbPremContactOrigTot */
  private ctrlG21: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotBbPremContactOrigTot = control.get('bavtotBbPremContactOrigTot').value;
    const bbPremContactOrigTot = Number(control.root.get('premiersContacts').get('bbPremContactOrigTot').value);

    if (bavtotBbPremContactOrigTot !== null && Number(bavtotBbPremContactOrigTot) > bbPremContactOrigTot) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG21': { value: control.value } } : null;
  }
  /* Controle sur bavtotBbPremContactModeEcrit */
  private ctrlG22: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotBbPremContactModeEcrit = control.get('bavtotBbPremContactModeEcrit').value;
    const bbPremContactModeEcrit = Number(control.root.get('premiersContacts').get('bbPremContactModeEcrit').value);

    if (bavtotBbPremContactModeEcrit !== null && Number(bavtotBbPremContactModeEcrit) > bbPremContactModeEcrit) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG22': { value: control.value } } : null;
  }
  /* Controle sur bavtotBbPremContactModeTel */
  private ctrlG23: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotBbPremContactModeTel = control.get('bavtotBbPremContactModeTel').value;
    const bbPremContactModeTel = Number(control.root.get('premiersContacts').get('bbPremContactModeTel').value);

    if (bavtotBbPremContactModeTel !== null && Number(bavtotBbPremContactModeTel) > bbPremContactModeTel) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG23': { value: control.value } } : null;
  }
  /* Controle sur bavtotBbPremContactModePres */
  private ctrlG24: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotBbPremContactModePres = control.get('bavtotBbPremContactModePres').value;
    const bbPremContactModePres = Number(control.root.get('premiersContacts').get('bbPremContactModePres').value);

    if (bavtotBbPremContactModePres !== null && Number(bavtotBbPremContactModePres) > bbPremContactModePres) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG24': { value: control.value } } : null;
  }
  /* Controle sur bavtotBbPremContactModeTot */
  private ctrlG25: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotBbPremContactModeTot = control.get('bavtotBbPremContactModeTot').value;
    const bbPremContactModeTot = Number(control.root.get('premiersContacts').get('bbPremContactModeTot').value);

    if (bavtotBbPremContactModeTot !== null && Number(bavtotBbPremContactModeTot) > bbPremContactModeTot) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG25': { value: control.value } } : null;
  }
  /* Controle sur bavtotCcRecuVictNb */
  private ctrlG26: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotCcRecuVictNb = control.get('bavtotCcRecuVictNb').value;
    const ccRecuVictNb = Number(control.root.get('personnesRecues').get('ccRecuVictNb').value);

    if (bavtotCcRecuVictNb !== null && Number(bavtotCcRecuVictNb) > ccRecuVictNb) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG26': { value: control.value } } : null;
  }
  /* Controle sur bavtotCcRecuNvictNb */
  private ctrlG27: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotCcRecuNvictNb = control.get('bavtotCcRecuNvictNb').value;
    const ccRecuNvictNb = Number(control.root.get('personnesRecues').get('ccRecuNvictNb').value);

    if (bavtotCcRecuNvictNb !== null && Number(bavtotCcRecuNvictNb) > ccRecuNvictNb) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG27': { value: control.value } } : null;
  }
  /* Controle sur bavtotCcRecuNbTot */
  private ctrlG28: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotCcRecuNbTot = control.get('bavtotCcRecuNbTot').value;
    const ccRecuNbTot = Number(control.root.get('personnesRecues').get('ccRecuNbTot').value);

    if (bavtotCcRecuNbTot !== null && Number(bavtotCcRecuNbTot) > ccRecuNbTot) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG28': { value: control.value } } : null;
  }
  /* Controle sur bavtotCcRecuVictSuivi */
  private ctrlG29: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotCcRecuVictSuivi = control.get('bavtotCcRecuVictSuivi').value;
    const ccRecuVictSuivi = Number(control.root.get('personnesRecues').get('ccRecuVictSuivi').value);

    if (bavtotCcRecuVictSuivi !== null && Number(bavtotCcRecuVictSuivi) > ccRecuVictSuivi) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG29': { value: control.value } } : null;
  }
  /* Controle sur bavtotCcRecuNvictSuivi */
  private ctrlG30: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotCcRecuNvictSuivi = control.get('bavtotCcRecuNvictSuivi').value;
    const ccRecuNvictSuivi = Number(control.root.get('personnesRecues').get('ccRecuNvictSuivi').value);

    if (bavtotCcRecuNvictSuivi !== null && Number(bavtotCcRecuNvictSuivi) > ccRecuNvictSuivi) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG30': { value: control.value } } : null;
  }
  /* Controle sur bavtotCcRecuSuiviTot */
  private ctrlG31: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotCcRecuSuiviTot = control.get('bavtotCcRecuSuiviTot').value;
    const ccRecuSuiviTot = Number(control.root.get('personnesRecues').get('ccRecuSuiviTot').value);

    if (bavtotCcRecuSuiviTot !== null && Number(bavtotCcRecuSuiviTot) > ccRecuSuiviTot) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG31': { value: control.value } } : null;
  }
  /* Controle sur bavtotCcRecuVictEntret */
  private ctrlG32: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotCcRecuVictEntret = control.get('bavtotCcRecuVictEntret').value;
    const ccRecuVictEntret = Number(control.root.get('personnesRecues').get('ccRecuVictEntret').value);

    if (bavtotCcRecuVictEntret !== null && Number(bavtotCcRecuVictEntret) > ccRecuVictEntret) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG32': { value: control.value } } : null;
  }
  /* Controle sur bavtotCcRecuNvictEntret */
  private ctrlG33: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotCcRecuNvictEntret = control.get('bavtotCcRecuNvictEntret').value;
    const ccRecuNvictEntret = Number(control.root.get('personnesRecues').get('ccRecuNvictEntret').value);

    if (bavtotCcRecuNvictEntret !== null && Number(bavtotCcRecuNvictEntret) > ccRecuNvictEntret) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG33': { value: control.value } } : null;
  }
  /* Controle sur bavtotCcRecuEntretTot */
  private ctrlG34: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotCcRecuEntretTot = control.get('bavtotCcRecuEntretTot').value;
    const ccRecuEntretTot = Number(control.root.get('personnesRecues').get('ccRecuEntretTot').value);

    if (bavtotCcRecuEntretTot !== null && Number(bavtotCcRecuEntretTot) > ccRecuEntretTot) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG34': { value: control.value } } : null;
  }
  /* Controle sur bavtotDdFaitPersoHomiVolo */
  private ctrlG35: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotDdFaitPersoHomiVolo = control.get('bavtotDdFaitPersoHomiVolo').value;
    const ddFaitPersoHomiVolo = Number(control.root.get('contexteFaitsProcedure').get('ddFaitPersoHomiVolo').value);

    if (bavtotDdFaitPersoHomiVolo !== null && Number(bavtotDdFaitPersoHomiVolo) > ddFaitPersoHomiVolo) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG35': { value: control.value } } : null;
  }
  /* Controle sur bavtotDdFaitPersoSexuel */
  private ctrlG36: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotDdFaitPersoSexuel = control.get('bavtotDdFaitPersoSexuel').value;
    const ddFaitPersoSexuel = Number(control.root.get('contexteFaitsProcedure').get('ddFaitPersoSexuel').value);

    if (bavtotDdFaitPersoSexuel !== null && Number(bavtotDdFaitPersoSexuel) > ddFaitPersoSexuel) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG36': { value: control.value } } : null;
  }
  /* Controle sur bavtotDdFaitPersoProxe */
  private ctrlG37: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotDdFaitPersoProxe = control.get('bavtotDdFaitPersoProxe').value;
    const ddFaitPersoProxe = Number(control.root.get('contexteFaitsProcedure').get('ddFaitPersoProxe').value);

    if (bavtotDdFaitPersoProxe !== null && Number(bavtotDdFaitPersoProxe) > ddFaitPersoProxe) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG37': { value: control.value } } : null;
  }
  /* Controle sur bavtotDdFaitPersoViolen */
  private ctrlG38: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotDdFaitPersoViolen = control.get('bavtotDdFaitPersoViolen').value;
    const ddFaitPersoViolen = Number(control.root.get('contexteFaitsProcedure').get('ddFaitPersoViolen').value);

    if (bavtotDdFaitPersoViolen !== null && Number(bavtotDdFaitPersoViolen) > ddFaitPersoViolen) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG38': { value: control.value } } : null;
  }
  /* Controle sur bavtotDdFaitPersoHomiInvolo */
  private ctrlG39: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotDdFaitPersoHomiInvolo = control.get('bavtotDdFaitPersoHomiInvolo').value;
    const ddFaitPersoHomiInvolo = Number(control.root.get('contexteFaitsProcedure').get('ddFaitPersoHomiInvolo').value);

    if (bavtotDdFaitPersoHomiInvolo !== null && Number(bavtotDdFaitPersoHomiInvolo) > ddFaitPersoHomiInvolo) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG39': { value: control.value } } : null;
  }
  /* Controle sur bavtotDdFaitPersoBless */
  private ctrlG40: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotDdFaitPersoBless = control.get('bavtotDdFaitPersoBless').value;
    const ddFaitPersoBless = Number(control.root.get('contexteFaitsProcedure').get('ddFaitPersoBless').value);

    if (bavtotDdFaitPersoBless !== null && Number(bavtotDdFaitPersoBless) > ddFaitPersoBless) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG40': { value: control.value } } : null;
  }
  /* Controle sur bavtotDdFaitPersoAband */
  private ctrlG41: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotDdFaitPersoAband = control.get('bavtotDdFaitPersoAband').value;
    const ddFaitPersoAband = Number(control.root.get('contexteFaitsProcedure').get('ddFaitPersoAband').value);

    if (bavtotDdFaitPersoAband !== null && Number(bavtotDdFaitPersoAband) > ddFaitPersoAband) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG41': { value: control.value } } : null;
  }
  /* Controle sur bavtotDdFaitPersoMenace */
  private ctrlG42: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotDdFaitPersoMenace = control.get('bavtotDdFaitPersoMenace').value;
    const ddFaitPersoMenace = Number(control.root.get('contexteFaitsProcedure').get('ddFaitPersoMenace').value);

    if (bavtotDdFaitPersoMenace !== null && Number(bavtotDdFaitPersoMenace) > ddFaitPersoMenace) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG42': { value: control.value } } : null;
  }
  /* Controle sur bavtotDdFaitPersoDiscri */
  private ctrlG43: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotDdFaitPersoDiscri = control.get('bavtotDdFaitPersoDiscri').value;
    const ddFaitPersoDiscri = Number(control.root.get('contexteFaitsProcedure').get('ddFaitPersoDiscri').value);

    if (bavtotDdFaitPersoDiscri !== null && Number(bavtotDdFaitPersoDiscri) > ddFaitPersoDiscri) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG43': { value: control.value } } : null;
  }
  /* Controle sur bavtotDdFaitPersoAutr */
  private ctrlG44: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotDdFaitPersoAutr = control.get('bavtotDdFaitPersoAutr').value;
    const ddFaitPersoAutr = Number(control.root.get('contexteFaitsProcedure').get('ddFaitPersoAutr').value);

    if (bavtotDdFaitPersoAutr !== null && Number(bavtotDdFaitPersoAutr) > ddFaitPersoAutr) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG44': { value: control.value } } : null;
  }
  /* Controle sur bavtotDdFaitPersoTot */
  private ctrlG45: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotDdFaitPersoTot = control.get('bavtotDdFaitPersoTot').value;
    const ddFaitPersoTot = Number(control.root.get('contexteFaitsProcedure').get('ddFaitPersoTot').value);

    if (bavtotDdFaitPersoTot !== null && Number(bavtotDdFaitPersoTot) > ddFaitPersoTot) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG45': { value: control.value } } : null;
  }
  /* Controle sur bavtotDdFaitBienVolSimp */
  private ctrlG46: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotDdFaitBienVolSimp = control.get('bavtotDdFaitBienVolSimp').value;
    const ddFaitBienVolSimp = Number(control.root.get('contexteFaitsProcedure').get('ddFaitBienVolSimp').value);

    if (bavtotDdFaitBienVolSimp !== null && Number(bavtotDdFaitBienVolSimp) > ddFaitBienVolSimp) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG46': { value: control.value } } : null;
  }
  /* Controle sur bavtotDdFaitBienVolAggr */
  private ctrlG47: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotDdFaitBienVolAggr = control.get('bavtotDdFaitBienVolAggr').value;
    const ddFaitBienVolAggr = Number(control.root.get('contexteFaitsProcedure').get('ddFaitBienVolAggr').value);

    if (bavtotDdFaitBienVolAggr !== null && Number(bavtotDdFaitBienVolAggr) > ddFaitBienVolAggr) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG47': { value: control.value } } : null;
  }
  /* Controle sur bavtotDdFaitBienEscro */
  private ctrlG48: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotDdFaitBienEscro = control.get('bavtotDdFaitBienEscro').value;
    const ddFaitBienEscro = Number(control.root.get('contexteFaitsProcedure').get('ddFaitBienEscro').value);

    if (bavtotDdFaitBienEscro !== null && Number(bavtotDdFaitBienEscro) > ddFaitBienEscro) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG48': { value: control.value } } : null;
  }
  /* Controle sur bavtotDdFaitBienDegrad */
  private ctrlG49: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotDdFaitBienDegrad = control.get('bavtotDdFaitBienDegrad').value;
    const ddFaitBienDegrad = Number(control.root.get('contexteFaitsProcedure').get('ddFaitBienDegrad').value);

    if (bavtotDdFaitBienDegrad !== null && Number(bavtotDdFaitBienDegrad) > ddFaitBienDegrad) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG49': { value: control.value } } : null;
  }
  /* Controle sur bavtotDdFaitBienAutr */
  private ctrlG50: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotDdFaitBienAutr = control.get('bavtotDdFaitBienAutr').value;
    const ddFaitBienAutr = Number(control.root.get('contexteFaitsProcedure').get('ddFaitBienAutr').value);

    if (bavtotDdFaitBienAutr !== null && Number(bavtotDdFaitBienAutr) > ddFaitBienAutr) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG50': { value: control.value } } : null;
  }
  /* Controle sur bavtotDdFaitBienTot */
  private ctrlG51: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotDdFaitBienTot = control.get('bavtotDdFaitBienTot').value;
    const ddFaitBienTot = Number(control.root.get('contexteFaitsProcedure').get('ddFaitBienTot').value);

    if (bavtotDdFaitBienTot !== null && Number(bavtotDdFaitBienTot) > ddFaitBienTot) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG51': { value: control.value } } : null;
  }
  /* Controle sur bavtotDdFaitCircuBless */
  private ctrlG52: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotDdFaitCircuBless = control.get('bavtotDdFaitCircuBless').value;
    const ddFaitCircuBless = Number(control.root.get('contexteFaitsProcedure').get('ddFaitCircuBless').value);

    if (bavtotDdFaitCircuBless !== null && Number(bavtotDdFaitCircuBless) > ddFaitCircuBless) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG52': { value: control.value } } : null;
  }
  /* Controle sur bavtotDdFaitCircuDegat */
  private ctrlG53: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotDdFaitCircuDegat = control.get('bavtotDdFaitCircuDegat').value;
    const ddFaitCircuDegat = Number(control.root.get('contexteFaitsProcedure').get('ddFaitCircuDegat').value);

    if (bavtotDdFaitCircuDegat !== null && Number(bavtotDdFaitCircuDegat) > ddFaitCircuDegat) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG53': { value: control.value } } : null;
  }
  /* Controle sur bavtotDdFaitCircuTot */
  private ctrlG54: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotDdFaitCircuTot = control.get('bavtotDdFaitCircuTot').value;
    const ddFaitCircuTot = Number(control.root.get('contexteFaitsProcedure').get('ddFaitCircuTot').value);

    if (bavtotDdFaitCircuTot !== null && Number(bavtotDdFaitCircuTot) > ddFaitCircuTot) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG54': { value: control.value } } : null;
  }
  /* Controle sur bavtotDdFaitAutr */
  private ctrlG55: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotDdFaitAutr = control.get('bavtotDdFaitAutr').value;
    const ddFaitAutr = Number(control.root.get('contexteFaitsProcedure').get('ddFaitAutr').value);

    if (bavtotDdFaitAutr !== null && Number(bavtotDdFaitAutr) > ddFaitAutr) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG55': { value: control.value } } : null;
  }
  /* Controle sur bavtotDdFaitTot */
  private ctrlG56: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotDdFaitTot = control.get('bavtotDdFaitTot').value;
    const ddFaitTot = Number(control.root.get('contexteFaitsProcedure').get('ddFaitTot').value);

    if (bavtotDdFaitTot !== null && Number(bavtotDdFaitTot) > ddFaitTot) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG56': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeEntretPsy */
  private ctrlG57: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeEntretPsy = control.get('bavtotEeEntretPsy').value;
    const eeEntretPsy = Number(control.root.get('aidesApportees').get('eeEntretPsy').value);

    if (bavtotEeEntretPsy !== null && Number(bavtotEeEntretPsy) > eeEntretPsy) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG57': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeEntretJur */
  private ctrlG58: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeEntretJur = control.get('bavtotEeEntretJur').value;
    const eeEntretJur = Number(control.root.get('aidesApportees').get('eeEntretJur').value);

    if (bavtotEeEntretJur !== null && Number(bavtotEeEntretJur) > eeEntretJur) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG58': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeEntretSoc */
  private ctrlG59: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeEntretSoc = control.get('bavtotEeEntretSoc').value;
    const eeEntretSoc = Number(control.root.get('aidesApportees').get('eeEntretSoc').value);

    if (bavtotEeEntretSoc !== null && Number(bavtotEeEntretSoc) > eeEntretSoc) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG59': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeEntretEcout */
  private ctrlG60: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeEntretEcout = control.get('bavtotEeEntretEcout').value;
    const eeEntretEcout = Number(control.root.get('aidesApportees').get('eeEntretEcout').value);

    if (bavtotEeEntretEcout !== null && Number(bavtotEeEntretEcout) > eeEntretEcout) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG60': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeEntretAutr */
  private ctrlG61: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeEntretAutr = control.get('bavtotEeEntretAutr').value;
    const eeEntretAutr = Number(control.root.get('aidesApportees').get('eeEntretAutr').value);

    if (bavtotEeEntretAutr !== null && Number(bavtotEeEntretAutr) > eeEntretAutr) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG61': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeEntretTot */
  private ctrlG62: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeEntretTot = control.get('bavtotEeEntretTot').value;
    const eeEntretTot = Number(control.root.get('aidesApportees').get('eeEntretTot').value);

    if (bavtotEeEntretTot !== null && Number(bavtotEeEntretTot) > eeEntretTot) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG62': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeDiliJur */
  private ctrlG63: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeDiliJur = control.get('bavtotEeDiliJur').value;
    const eeDiliJur = Number(control.root.get('aidesApportees').get('eeDiliJur').value);

    if (bavtotEeDiliJur !== null && Number(bavtotEeDiliJur) > eeDiliJur) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG63': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeDiliCivi */
  private ctrlG64: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeDiliCivi = control.get('bavtotEeDiliCivi').value;
    const eeDiliCivi = Number(control.root.get('aidesApportees').get('eeDiliCivi').value);

    if (bavtotEeDiliCivi !== null && Number(bavtotEeDiliCivi) > eeDiliCivi) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG64': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeDiliFondGaran */
  private ctrlG65: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeDiliFondGaran = control.get('bavtotEeDiliFondGaran').value;
    const eeDiliFondGaran = Number(control.root.get('aidesApportees').get('eeDiliFondGaran').value);

    if (bavtotEeDiliFondGaran !== null && Number(bavtotEeDiliFondGaran) > eeDiliFondGaran) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG65': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeDiliSarvi */
  private ctrlG66: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeDiliSarvi = control.get('bavtotEeDiliSarvi').value;
    const eeDiliSarvi = Number(control.root.get('aidesApportees').get('eeDiliSarvi').value);

    if (bavtotEeDiliSarvi !== null && Number(bavtotEeDiliSarvi) > eeDiliSarvi) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG66': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeDiliPenit */
  private ctrlG67: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeDiliPenit = control.get('bavtotEeDiliPenit').value;
    const eeDiliPenit = Number(control.root.get('aidesApportees').get('eeDiliPenit').value);

    if (bavtotEeDiliPenit !== null && Number(bavtotEeDiliPenit) > eeDiliPenit) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG67': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeDiliPolgend */
  private ctrlG68: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeDiliPolgend = control.get('bavtotEeDiliPolgend').value;
    const eeDiliPolgend = Number(control.root.get('aidesApportees').get('eeDiliPolgend').value);

    if (bavtotEeDiliPolgend !== null && Number(bavtotEeDiliPolgend) > eeDiliPolgend) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG68': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeDiliAvoc */
  private ctrlG69: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeDiliAvoc = control.get('bavtotEeDiliAvoc').value;
    const eeDiliAvoc = Number(control.root.get('aidesApportees').get('eeDiliAvoc').value);

    if (bavtotEeDiliAvoc !== null && Number(bavtotEeDiliAvoc) > eeDiliAvoc) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG69': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeDiliHuis */
  private ctrlG70: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeDiliHuis = control.get('bavtotEeDiliHuis').value;
    const eeDiliHuis = Number(control.root.get('aidesApportees').get('eeDiliHuis').value);

    if (bavtotEeDiliHuis !== null && Number(bavtotEeDiliHuis) > eeDiliHuis) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG70': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeDiliOrgaSoc */
  private ctrlG71: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeDiliOrgaSoc = control.get('bavtotEeDiliOrgaSoc').value;
    const eeDiliOrgaSoc = Number(control.root.get('aidesApportees').get('eeDiliOrgaSoc').value);

    if (bavtotEeDiliOrgaSoc !== null && Number(bavtotEeDiliOrgaSoc) > eeDiliOrgaSoc) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG71': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeDiliColter */
  private ctrlG72: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeDiliColter = control.get('bavtotEeDiliColter').value;
    const eeDiliColter = Number(control.root.get('aidesApportees').get('eeDiliColter').value);

    if (bavtotEeDiliColter !== null && Number(bavtotEeDiliColter) > eeDiliColter) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG72': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeDiliPref */
  private ctrlG73: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeDiliPref = control.get('bavtotEeDiliPref').value;
    const eeDiliPref = Number(control.root.get('aidesApportees').get('eeDiliPref').value);

    if (bavtotEeDiliPref !== null && Number(bavtotEeDiliPref) > eeDiliPref) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG73': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeDiliOrgaLogt */
  private ctrlG74: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeDiliOrgaLogt = control.get('bavtotEeDiliOrgaLogt').value;
    const eeDiliOrgaLogt = Number(control.root.get('aidesApportees').get('eeDiliOrgaLogt').value);

    if (bavtotEeDiliOrgaLogt !== null && Number(bavtotEeDiliOrgaLogt) > eeDiliOrgaLogt) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG74': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeDiliHebgt */
  private ctrlG75: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeDiliHebgt = control.get('bavtotEeDiliHebgt').value;
    const eeDiliHebgt = Number(control.root.get('aidesApportees').get('eeDiliHebgt').value);

    if (bavtotEeDiliHebgt !== null && Number(bavtotEeDiliHebgt) > eeDiliHebgt) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG75': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeDiliHosto */
  private ctrlG76: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeDiliHosto = control.get('bavtotEeDiliHosto').value;
    const eeDiliHosto = Number(control.root.get('aidesApportees').get('eeDiliHosto').value);

    if (bavtotEeDiliHosto !== null && Number(bavtotEeDiliHosto) > eeDiliHosto) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG76': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeDiliAsso */
  private ctrlG77: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeDiliAsso = control.get('bavtotEeDiliAsso').value;
    const eeDiliAsso = Number(control.root.get('aidesApportees').get('eeDiliAsso').value);

    if (bavtotEeDiliAsso !== null && Number(bavtotEeDiliAsso) > eeDiliAsso) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG77': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeDiliAssur */
  private ctrlG78: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeDiliAssur = control.get('bavtotEeDiliAssur').value;
    const eeDiliAssur = Number(control.root.get('aidesApportees').get('eeDiliAssur').value);

    if (bavtotEeDiliAssur !== null && Number(bavtotEeDiliAssur) > eeDiliAssur) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG78': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeDiliSad */
  private ctrlG79: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeDiliSad = control.get('bavtotEeDiliSad').value;
    const eeDiliSad = Number(control.root.get('aidesApportees').get('eeDiliSad').value);

    if (bavtotEeDiliSad !== null && Number(bavtotEeDiliSad) > eeDiliSad) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG79': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeDiliFrserv */
  private ctrlG80: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeDiliFrserv = control.get('bavtotEeDiliFrserv').value;
    const eeDiliFrserv = Number(control.root.get('aidesApportees').get('eeDiliFrserv').value);

    if (bavtotEeDiliFrserv !== null && Number(bavtotEeDiliFrserv) > eeDiliFrserv) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG80': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeDiliAutr */
  private ctrlG81: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeDiliAutr = control.get('bavtotEeDiliAutr').value;
    const eeDiliAutr = Number(control.root.get('aidesApportees').get('eeDiliAutr').value);

    if (bavtotEeDiliAutr !== null && Number(bavtotEeDiliAutr) > eeDiliAutr) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG81': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeDiliTot */
  private ctrlG82: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeDiliTot = control.get('bavtotEeDiliTot').value;
    const eeDiliTot = Number(control.root.get('aidesApportees').get('eeDiliTot').value);

    if (bavtotEeDiliTot !== null && Number(bavtotEeDiliTot) > eeDiliTot) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG82': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeAideCivi */
  private ctrlG83: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeAideCivi = control.get('bavtotEeAideCivi').value;
    const eeAideCivi = Number(control.root.get('aidesApportees').get('eeAideCivi').value);

    if (bavtotEeAideCivi !== null && Number(bavtotEeAideCivi) > eeAideCivi) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG83': { value: control.value } } : null;
  }
  /* Controle sur bavtotEeAideSarvi */
  private ctrlG84: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    let resultat: boolean = false;
    const bavtotEeAideSarvi = control.get('bavtotEeAideSarvi').value;
    const eeAideSarvi = Number(control.root.get('aidesApportees').get('eeAideSarvi').value);

    if (bavtotEeAideSarvi !== null && Number(bavtotEeAideSarvi) > eeAideSarvi) {
      resultat = true;
    } else {
      resultat = false;
    }
    return resultat ? { 'ctrlG84': { value: control.value } } : null;
  }

}
